export const common = {
  // Navigatie
  'nav.features': 'Functies',
  'nav.howItWorks': 'Hoe het werkt',
  'nav.pricing': 'Prijzen',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Over Ons',
  'nav.getStarted': 'Begin',

  // Over Ons Sectie
  'aboutUs.badge': "Over ons",
  'aboutUs.title': "Waarom IdeaVerdict bestaat",
  'aboutUs.line1': "Iedereen kan een idee hebben.",
  'aboutUs.line2': "Weinigen geven toe dat het hunne niet standhoudt.",
  'aboutUs.paragraph1':
    "De meeste ideeën falen niet uit gebrek aan moed. Ze falen omdat niemand op tijd de waarheid zei. IdeaVerdict vult dat gat — we geven je het brute oordeel dat je vrienden niet geven.",
  'aboutUs.belief1a': "We handelen niet in hype.",
  'aboutUs.belief1b': "We handelen in marktsignalen.",
  'aboutUs.belief2a': "We verkopen geen motivatie.",
  'aboutUs.belief2b': "We verkopen een helder beeld van vraag, concurrentie en haalbaarheid.",
  'aboutUs.mission1': "Onze taak is niet om je idee er goed uit te laten zien.",
  'aboutUs.mission2': "Onze taak is om je te vertellen of het dat is.",
  'aboutUs.analysis':
    "IdeaVerdict beoordeelt ideeën op wat ertoe doet — marktstructuur, echte vraag, concurrentie, benodigd kapitaal, time-to-revenue, schaalbaarheid. Geen emotie. Geen optimisme. Alleen analyse.",
  'aboutUs.failure1': "De meeste bedrijven falen.",
  'aboutUs.failure2': "Niet omdat de mensen erachter incompetent waren —",
  'aboutUs.failure3': "maar omdat niemand sterk genoeg, vroeg genoeg, tegengas gaf.",
  'aboutUs.clarity': "We bestaan om tegengas te geven.",
  'aboutUs.value1': "Direct.",
  'aboutUs.value2': "Eerlijk.",
  'aboutUs.value3': "Snel.",
  'aboutUs.confirm': "Als je idee substantie heeft, onderbouwen we het.",
  'aboutUs.deny': "Zo niet, dan zeggen we het in je gezicht.",
  'aboutUs.noApplause': "Geen applaus.",
  'aboutUs.noSugarcoating': "Geen verdoezeling.",
  'aboutUs.noTheater': "Geen theater.",
  'aboutUs.noHype': "Alleen het oordeel.",
  // Hero Sectie
  'hero.badge': 'AI-oordeel in minder dan 60 seconden',
  'hero.title1': 'Bouw niets',
  'hero.title2': 'voordat je het checkt.',
  'hero.subtitle': 'IdeaVerdict toetst je idee als een sceptische VC.',
  'hero.subtitleLine2': 'Eerlijk oordeel in seconden — geen hype, geen vleierij.',
  'hero.cta': 'Krijg mijn oordeel',
  'hero.ctaSecondary': 'Hoe het werkt',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits per aanvraag',
  'hero.stat2Value': 'Vanaf 7',
  'hero.stat2Label': 'Beoordelingsdimensies',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Eerlijk & Privaat',

  // Functies Sectie
  'features.title1': 'Gemaakt voor',
  'features.title2': 'oprichters die',
  'features.title3': 'de waarheid willen',
  'features.bullet1.title': 'Eerlijk oordeel in seconden',
  'features.bullet1.description':
    'Sterk, Gemengd of Zwak — met de onderbouwing erbij. Geen applaus, geen mooipraat, geen theater.',
  'features.bullet2.title': 'Beoordeeld op wat telt',
  'features.bullet2.description':
    'Je idee wordt beoordeeld op echte vraag, concurrentie, benodigd kapitaal, tijd tot omzet en schaalbaarheid — niet op vibes.',
  'features.bullet3.title': 'Van oordeel naar product',
  'features.bullet3.description':
    'Builder-modus zet een goedgekeurd idee om in een developer-briefing: user flows, kernfuncties, technische notities.',

  // Hoe Het Werkt
  'howItWorks.title': 'Hoe het werkt',
  'howItWorks.subtitle': 'Vier stappen naar duidelijkheid over uw bedrijfsniche.',
  'howItWorks.step1Title': 'Kies een plan',
  'howItWorks.step1Desc': 'Starter, Pro of Builder – afhankelijk van de diepgang van uw beoordeling.',
  'howItWorks.step2Title': 'Stel de AI de vraag',
  'howItWorks.step2Desc': 'Stel uw vragen over de niche. Elke aanvraag kost 30 credits.',
  'howItWorks.step3Title': 'Krijg eerlijk oordeel',
  'howItWorks.step3Desc': 'De AI beoordeelt: Goed, Gemiddeld of Slecht. Geen opsmuk.',
  'howItWorks.step4Title': 'Neem een beslissing',
  'howItWorks.step4Desc': "Nu weet u of het de moeite waard is om verder te gaan.",

  // Prijzen
  'pricing.title': 'Prijzen',
  'pricing.subtitle': 'Kies het plan dat past bij uw analysebehoefte.',
  'pricing.monthly': 'Maandelijks',
  'pricing.yearly': 'Jaarlijks',
  'pricing.yearlyDiscount': 'Jaarabonnement:',
  'pricing.yearlyDiscountValue': '-20% korting',
  'pricing.perMonth': 'per maand',
  'pricing.selectPlan': 'Selecteer Plan',
  'pricing.mostPopular': 'Meest Populair',
  'pricing.footer':
    'Alle prijzen in CHF. Credits worden alleen afgeschreven voor succesvolle AI-reacties.',

  
  // Pricing Features
  'pricing.feature1': 'Gratis Chat (geen formulier)',
  'pricing.feature2': 'Marktlogica & eerlijke beoordeling',
  'pricing.feature3': 'Persistente chatgeschiedenis',
  'pricing.feature4': 'Meerdere parallelle chatsessies',
  'pricing.feature5': 'Volledig meertalig',
  'pricing.feature6': 'Op credits gebaseerd gebruik',
  'pricing.feature7': 'Maandelijkse reset',
  'pricing.feature8': 'Marktanalyse',
  'pricing.feature9': 'Samenvatting',
  'pricing.feature10': 'Sterke punten',
  'pricing.feature11': 'Zwakke punten',
  'pricing.feature12': 'Kansen',
  'pricing.feature13': 'Risico\'s',
  'pricing.feature14': 'Aanbevelingen',
  'pricing.feature15': 'PDF downloaden',
  'pricing.feature16': 'Geen ontwikkelaarsbriefings',
  'pricing.feature17': 'Builder modus: Ontwikkelaarsbriefings',
  'pricing.feature18': 'Gestructureerde samenvatting',

  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.price': '39.90',
  'pricing.starter.description': 'Toegang tot AI niche chatbot',
  'pricing.starter.credits': '2.500 Credits per maand',
  'pricing.starter.feature1': 'Genereer niche-idee',
  'pricing.starter.feature2': 'Verfijn niche',
  'pricing.starter.feature3': 'Realiteitscheck markt',
  'pricing.starter.feature4': 'Concurrentiebeoordeling',
  'pricing.starter.feature5': 'Tijdsinschatting',
  'pricing.starter.feature6': 'Eerlijk oordeel',
  'pricing.starter.feature7': 'Privésessies',
  'pricing.starter.feature8': 'Geschiedenis & export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.price': '59.90',
  'pricing.pro.description': 'Toegang tot AI niche chatbot',
  'pricing.pro.credits': '5.000 Credits per maand',
  'pricing.pro.feature1': 'Alle Starter-functies',
  'pricing.pro.feature2': 'Meer credits voor intensieve beoordeling',
  'pricing.pro.feature3': 'Verbeteringssuggesties',
  'pricing.pro.feature4': 'Alternatieve niches',
  'pricing.pro.feature5': 'Gedetailleerde marktanalyse',
  'pricing.pro.feature6': 'Prioriteit ondersteuning',
  'pricing.pro.feature7': 'Geavanceerde filters',
  'pricing.pro.feature8': 'Sessiefavorieten',

  // Builder Plan
  'pricing.builder.name': "Builder",
  'pricing.builder.price': '199',
  'pricing.builder.description': "Alle functies + Builder-modus",
  'pricing.builder.credits': "10.000 credits per maand",
  'pricing.builder.feature1': 'Alle Pro-functies',
  'pricing.builder.feature2': 'Ongelimiteerde AI-aanvragen',
  'pricing.builder.feature3': 'Builder-modus: Ontwikkelaarsspecificaties',
  'pricing.builder.feature4': 'Gestructureerd projectoverzicht',
  'pricing.builder.feature5': 'Gebruikersstromen & kernfuncties',
  'pricing.builder.feature6': 'Technische notities',
  'pricing.builder.feature7': 'Definieer non-doelen',
  'pricing.builder.feature8': 'Fair use-limiet',
  'pricing.builder.limitNote': 'Fair use-limiet',
  'pricing.monthlyReset': 'Maandelijkse reset',

  // Modaal
  'pricing.modal.selected': 'geselecteerd',
  'pricing.modal.comingSoon':
    'Registratie en betalingsverwerking zijn binnenkort beschikbaar.',
  'pricing.modal.patience':
    'We werken eraan om u een veilige en naadloze ervaring te bieden. We vragen om uw geduld.',
  'pricing.modal.understood': 'Begrepen',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Eerlijk & kritisch beantwoord.',
  'faq.q1': "Wat doet IdeaVerdict eigenlijk?",
  'faq.a1': "Het beoordeelt je bedrijfsidee op wat succes bepaalt — echte vraag, concurrentie, benodigd kapitaal, time-to-market en schaalbaarheid.\nAls het idee standhoudt, laten we zien hoe je het aanscherpt.\nZo niet, dan zeggen we dat ook.",
  'faq.q2': "Genereren jullie ook ideeën?",
  'faq.a2': "Ja — maar geen willekeurige suggesties.\nIdeeën komen uit echte marktgaten, niet uit wat deze week trending is.",
  'faq.q3': "Verbeteren jullie bestaande businessmodellen?",
  'faq.a3': "Ja, als er iets te verbeteren valt.\nWe poetsen geen kapotte ideeën — we versterken degene die al een basis hebben.",
  'faq.q4': "Hoe verschillen jullie van andere AI-tools?",
  'faq.a4': "De meeste AI-tools vertellen dat je idee geweldig is.\nWij vertellen of het dat ook echt is.\nHet verschil: realisme in plaats van enthousiasme.",
  'faq.q5': "Garandeert dit succes?",
  'faq.a5': "Nee.\nWe helpen je slechte weddenschappen te vermijden — risico verdwijnt niet, maar je gaat met open ogen naar binnen.",
  'faq.q6': "Voor wie is IdeaVerdict?",
  'faq.a6': "Founders vóór de launch.\nBuilders vóór het side-project-weekend.\nOperators vóór de volgende gok.\nInvesteerders vóór de handtekening.\n\nVoor iedereen die helderheid wil vóór commitment.",
  'faq.q7': "En als ik alleen bevestiging zoek?",
  'faq.a7': "Dan is IdeaVerdict de verkeerde tool.\nWe leveren een eerlijk oordeel, geen geruststelling.",
  'faq.q8': "Hoe eerlijk is de analyse echt?",
  'faq.a8': "Zo eerlijk als de data toelaat.\nWe verzachten geen zwak oordeel om gevoelens te sparen.",
  'faq.q9': "Vervangt dit echt marktonderzoek?",
  'faq.a9': "Nee.\nHet is een snelle strategische check voor je investeert — geen 50-pagina-studie.",
  'faq.q10': "Waarom zo direct?",
  'faq.a10': "Omdat het verkeerde bouwen maanden kost.\nEen eerlijk oordeel kost minuten.\n\nWij kiezen de minuten.",
  // Footer
  'footer.description':
    'IdeaVerdict is er niet om jou een goed gevoel te geven. Het is er om je goed te laten beslissen.',
  'footer.product': 'Product',
  'footer.aiAssistant': 'AI Assistent',
  'footer.howItWorks': 'Hoe het werkt',
  'footer.pricing': 'Prijzen',
  'footer.faq': 'FAQ',
  'footer.legal': 'Juridisch',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Voorwaarden',
  'footer.imprint': 'Impressum',
  'footer.support': 'Ondersteuning',
  'footer.contact': 'Contact',
  'footer.documentation': 'Documentatie',
  'footer.copyright': '© 2026 IdeaVerdict. Alle rechten voorbehouden.',

  // AI Assistent
  'aiAssistant.title': 'AI Niche Assistent',
  'aiAssistant.subtitle': 'Vraag naar niches',
  'aiAssistant.welcomeMessage':
    'Hallo! Beschrijf uw idee of vraag me naar een niche. Ik geef u een duidelijke en eerlijke evaluatie.',
  'aiAssistant.demoResponse':
    'Dit is een demo. Voor echte AI-evaluaties moet u zich registreren en een plan kiezen.',
  'aiAssistant.placeholder': 'Beschrijf uw idee...',

  // Header & Zijbalk
  'dashboard.header.title': 'Dashboard',
  'dashboard.header.aiAssistant': 'Uw AI Assistent',
  'header.logout': 'Uitloggen',
  'dashboard.sidebar.overview': 'Overzicht',
  'dashboard.sidebar.aiChat': 'AI Assistent',
  'dashboard.sidebar.newAnalysis': 'AI Assistent',
  'dashboard.sidebar.history': 'Geschiedenis',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.settings': 'Instellingen',

  // Dashboard Overzicht
  'dashboard.overview.welcome': 'Welkom terug, {{name}}',
  'dashboard.overview.subtitle':
    'Hier is een snel overzicht van uw activiteit',

  // Dashboard Statistieken
  'dashboard.stats.creditsRemaining': 'Resterende credits',
  'dashboard.stats.totalAnalyses': 'Totaal analyses',
  'dashboard.stats.goodRatings': 'Positieve beoordelingen',
  'dashboard.stats.nextReset': 'Volgende reset over',
  'dashboard.stats.days': 'dagen',

  // Snelle Acties
  'dashboard.quickActions.title': 'Snelle acties',
  'dashboard.quickActions.checkNewIdea': 'Check een idee',
  'dashboard.quickActions.checkNewIdeaDesc':
    'Analyseer een bestaand bedrijfsidee',
  'dashboard.quickActions.generateIdea': 'Genereer een idee',
  'dashboard.quickActions.generateIdeaDesc':
    'Vind een nieuwe winstgevende niche',
  'dashboard.quickActions.builderBriefing': 'Builder briefing',
  'dashboard.quickActions.builderBriefingDesc':
    'Zet een idee om in een ontwikkelaarsklare briefing',
  'dashboard.quickActions.premiumOnly': 'Alleen Builder',

  // Chat Header
  'chat.title': 'AI Niche Assistent',
  'chat.subtitle':
    'Stel vragen over niches. Ik evalueer kritisch en eerlijk.',
  'chat.creditsLabel': 'Credits',

  // Chat Welkom
  'chat.welcomeTitle': 'Welkom bij de AI Niche Assistent',
  'chat.welcomeDesc':
    'Beschrijf uw idee of vraag naar een niche. Ik zal het eerlijk evalueren: Goed, Gemiddeld of Slecht.',
  'chat.aiWelcome':
    'Hallo! Beschrijf uw idee of vraag me naar een niche. Ik geef u een duidelijke en eerlijke evaluatie.',

  // Chat Suggesties
  'chat.suggestion1': 'Ik wil een SaaS-tool bouwen voor freelancers om facturen te beheren. Is dit een goede niche?',
  'chat.suggestion2': 'Vind een online business met weinig concurrentie die ik kan starten met $500 zonder programmeerkennis.',
  'chat.suggestion3': 'Beoordeel dit: een AI-maaltijdplanning-app voor drukke ouders met dieetbeperkingen.',
  'chat.suggestion4': 'Ik wil digitale templates verkopen op Etsy voor kleine ondernemers. Analyseer deze niche eerlijk.',

  // Chat Acties
  'chat.newConversation': 'Nieuw gesprek',
  'chat.today': 'Vandaag',
  'chat.yesterday': 'Gisteren',
  'chat.thisWeek': 'Deze week',
  'chat.thisMonth': 'Deze maand',
  'chat.older': 'Ouder',
  'chat.messages': 'berichten',
  'chat.renameConversation': 'Hernoemen',
  'chat.deleteConversation': 'Verwijderen',
  'chat.cancel': 'Annuleren',
  'chat.rename': 'Hernoemen',
  'chat.delete': 'Verwijderen',
  'chat.favorite': 'Toevoegen aan favorieten',
  'chat.unfavorite': 'Verwijder uit favorieten',
  'chat.searchSessions': 'Zoek gesprekken...',
  'chat.noResults': 'Geen resultaten gevonden',
  'chat.noSessions': 'Nog geen gesprekken',
  'chat.enterNewName': 'Voer nieuwe naam in...',
  'chat.deleteConfirmMessage':
    'Weet u zeker dat u dit gesprek wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',

  // Chat Invoer & Fouten
  'chat.inputPlaceholder': 'Typ uw vraag… (kost 30 credits)',
  'chat.send': 'Verstuur',
  'chat.voice': 'Spreek',
  'chat.listeningPlaceholder': 'Ik luister... Spreek nu.',
  'chat.stopListening': 'Stop met luisteren',
  'chat.recording': 'Opnemen...',
  'chat.speechNotSupported': 'Uw browser ondersteunt geen spraakherkenning.',
  'chat.microphonePermissionDenied': 'Microfoontoegang geweigerd. Sta toegang toe in browserinstellingen.',
  'chat.errorNotEnoughCredits':
    'Niet genoeg credits. Upgrade uw plan of wacht op de volgende reset.',
  'chat.errorAiFailed': 'AI-reactie mislukt. Er zijn geen credits afgeschreven.',
  'chat.errorRateLimit': 'Te veel aanvragen. Wacht even.',

  // Beoordelingen
  'rating.good': 'Goed',
  'rating.medium': 'Gemiddeld',
  'rating.bad': 'Slecht',

  // Auth Pagina
  'auth.branding.headline1': 'Niet elk idee is goed.',
  'auth.branding.headline2': 'Wij vertellen u eerlijk.',
  'auth.branding.subtitle':
    'Een beslissings-AI voor bedrijfsniches. Helder. Kritisch. Geen opsmuk.',
  'auth.benefits.privacy.title': '100% Privaat',
  'auth.benefits.privacy.desc':
    'Uw ideeën blijven volledig privé en veilig.',
  'auth.benefits.honest.title': 'Eerlijke AI',
  'auth.benefits.honest.desc':
    'Geen opsmuk – alleen duidelijke, kritische feedback.',
  'auth.benefits.fast.title': 'Snelle Resultaten',
  'auth.benefits.fast.desc': 'Krijg duidelijkheid over uw niche in minuten.',
  'auth.trust.users': 'Actieve Gebruikers',
  'auth.trust.ideas': 'Geanalyseerde Ideeën',
  'auth.trust.rating': 'Gebruikersbeoordeling',
  'auth.login.title': 'Inloggen',
  'auth.login.headline': 'Welkom terug',
  'auth.login.subtitle': 'Log in om verder te gaan met uw reis.',
  'auth.login.forgotPassword': 'Wachtwoord vergeten?',
  'auth.login.submit': 'Inloggen',
  'auth.login.noAccount': 'Nog geen account?',
  'auth.login.signUp': 'Registreren',
  'auth.register.title': 'Registreren',
  'auth.register.headline': 'Maak uw account aan',
  'auth.register.subtitle':
    'Begin vandaag met het analyseren van uw bedrijfsideeën.',
  'auth.register.submit': 'Account aanmaken',
  'auth.register.hasAccount': 'Al een account?',
  'auth.register.signIn': 'Inloggen',
  'auth.fields.name': 'Volledige naam',
  'auth.fields.email': 'E-mailadres',
  'auth.fields.password': 'Wachtwoord',
  'auth.fields.confirmPassword': 'Bevestig wachtwoord',
  'auth.fields.selectPlan': 'Selecteer uw plan',
  'auth.fields.testCode': 'Login en test gratis',
  'auth.placeholders.name': 'Voer uw naam in',
  'auth.placeholders.email': 'Voer uw e-mail in',
  'auth.placeholders.password': 'Voer uw wachtwoord in',
  'auth.placeholders.confirmPassword': 'Bevestig uw wachtwoord',
  'auth.placeholders.testCode': 'Voer testcode in',
  'auth.terms.accept': 'Ik ga akkoord met de',
  'auth.terms.terms': 'Algemene Voorwaarden',
  'auth.privacy.accept': 'Ik ga akkoord met het',
  'auth.privacy.policy': 'Privacybeleid',
  'auth.errors.nameRequired': 'Naam is verplicht',
  'auth.errors.emailRequired': 'E-mail is verplicht',
  'auth.errors.emailInvalid': 'Voer een geldig e-mailadres in',
  'auth.errors.passwordRequired': 'Wachtwoord is verplicht',
  'auth.errors.passwordLength': 'Wachtwoord moet minimaal 8 tekens bevatten',
  'auth.errors.passwordMismatch': 'Wachtwoorden komen niet overeen',
  'auth.errors.invalidCode': 'Ongeldige of verlopen code',
  'auth.errors.registrationCodeOnly': 'Deze code is alleen voor registratie',
  'auth.errors.verificationFailed': 'Fout bij verifiëren van code. Probeer opnieuw.',
  'auth.loading': 'Even geduld...',
  'auth.or': 'of ga verder met',
  'auth.social.google': 'Ga verder met Google',
  'auth.social.apple': 'Ga verder met Apple',
  'auth.actions.verify': 'Verifiëren',
  'auth.testCode.activated': 'Testcode geactiveerd!',
  'auth.testCode.days': 'dagen',
  'auth.testCode.months': 'maanden',
  'auth.testCode.freeAccess': 'gratis toegang',
  'auth.testCode.credits': 'credits',

  // E-mail Verificatie
  'auth.verification.title': 'Verifieer E-mail',
  'auth.verification.headline': 'Check uw inbox',
  'auth.verification.subtitle': 'We hebben een verificatiecode gestuurd naar:',
  'auth.verification.codeLabel': 'Verificatiecode',
  'auth.verification.codePlaceholder': 'Voer 6-cijferige code in',
  'auth.verification.submit': 'Verifieer E-mail',
  'auth.verification.resend': 'Code opnieuw verzenden',
  'auth.verification.resendIn': 'Opnieuw verzenden over',
  'auth.verification.seconds': 'seconden',
  'auth.verification.success': 'E-mail succesvol geverifieerd!',
  'auth.verification.error': 'Ongeldige code. Probeer opnieuw.',
  'auth.verification.expired': 'Code verlopen. Vraag een nieuwe aan.',
  'auth.verification.sent': 'Nieuwe code verzonden!',
  'auth.verification.checkSpam':
    "Niet ontvangen? Controleer uw spammap.",

  // Wachtwoord Vergeten
  'auth.forgot.title': 'Wachtwoord Vergeten',
  'auth.forgot.headline': 'Reset uw wachtwoord',
  'auth.forgot.subtitle':
    "Voer uw e-mailadres in en we sturen u een resetlink.",
  'auth.forgot.submit': 'Verstuur Resetlink',
  'auth.forgot.backToLogin': 'Terug naar inloggen',
  'auth.forgot.success': 'E-mail verzonden!',
  'auth.forgot.successMessage':
    "We hebben u een e-mail gestuurd met instructies om uw wachtwoord te resetten.",
  'auth.forgot.checkInbox': 'Check uw inbox',

  // Wachtwoord Resetten
  'auth.reset.title': 'Nieuw Wachtwoord',
  'auth.reset.headline': 'Stel nieuw wachtwoord in',
  'auth.reset.subtitle': 'Voer uw nieuwe wachtwoord in.',
  'auth.reset.newPassword': 'Nieuw Wachtwoord',
  'auth.reset.confirmNewPassword': 'Bevestig Nieuw Wachtwoord',
  'auth.reset.submit': 'Wachtwoord Wijzigen',
  'auth.reset.success': 'Wachtwoord succesvol gewijzigd!',
  'auth.reset.successMessage':
    'U kunt nu inloggen met uw nieuwe wachtwoord.',
  'auth.reset.loginNow': 'Log nu in',

  // Juridische Pagina's
  'legal.backToAuth': 'Terug naar inloggen',
  'legal.allRightsReserved': 'Alle rechten voorbehouden.',

  // Algemene Voorwaarden Pagina
  'legal.terms.title': 'Algemene Voorwaarden',
  'legal.terms.lastUpdated': 'Laatst bijgewerkt',
  'legal.terms.section1.title': '1. Toepassingsgebied',
  'legal.terms.section1.content':
    'Deze Algemene Voorwaarden zijn van toepassing op alle overeenkomsten tussen NicheFinder (hierna "Aanbieder") en de gebruiker (hierna "Klant") met betrekking tot het gebruik van het AI-gestuurde nicheanalyseplatform.',
  'legal.terms.section2.title': '2. Dienstenbeschrijving',
  'legal.terms.section2.content':
    'De Aanbieder biedt een AI-gebaseerd platform dat bedrijfsideeën en niches analyseert en evalueert. Diensten omvatten:',
  'legal.terms.section2.item1': 'AI-gestuurde analyse van bedrijfsideeën',
  'legal.terms.section2.item2': 'Evaluatie van marktpotentieel en concurrentie',
  'legal.terms.section2.item3': 'Generatie van nichesuggesties',
  'legal.terms.section2.item4': 'Creatie van ontwikkelaarsspecificaties (Builder-pakket)',
  'legal.terms.section3.title': '3. Contractsluiting en Registratie',
  'legal.terms.section3.content':
    'De overeenkomst komt tot stand door registratie op het platform en selectie van een pakket. De klant bevestigt:',
  'legal.terms.section3.item1': 'Meerderjarig en volledig handelingsbekwaam te zijn',
  'legal.terms.section3.item2': 'Waarheidsgetrouwe informatie te verstrekken bij registratie',
  'legal.terms.section3.item3': 'Toegangsgegevens veilig op te slaan',
  'legal.terms.section4.title': '4. Credits en Facturatie',
  'legal.terms.section4.content':
    'Het gebruik van AI-functies is gebaseerd op een creditsysteem. Elke AI-aanvraag kost 30 credits. Credits worden alleen afgeschreven bij een succesvolle reactie. Ongebruikte credits vervallen aan het einde van de factureringsperiode en worden niet terugbetaald.',
  'legal.terms.section5.title': '5. Vrijwaring',
  'legal.terms.section5.content':
    'AI-evaluaties dienen uitsluitend als beslissingsondersteuning en garanderen geen bedrijfssucces. De Aanbieder is niet aansprakelijk voor beslissingen die zijn genomen op basis van AI-analyses. Aansprakelijkheid voor opzet en grove nalatigheid blijft onaangetast.',
  'legal.terms.section6.title': '6. Gegevensbescherming en Vertrouwelijkheid',
  'legal.terms.section6.content':
    'Alle ingediende bedrijfsideeën worden vertrouwelijk behandeld en niet aan derden verstrekt. De verwerking van persoonsgegevens gebeurt in overeenstemming met ons Privacybeleid en de toepasselijke wetgeving inzake gegevensbescherming.',
  'legal.terms.section7.title': '7. Beëindiging',
  'legal.terms.section7.content':
    'De klant kan zijn abonnement te allen tijde opzeggen tegen het einde van de lopende factureringsperiode. Bij overtreding van deze Voorwaarden behoudt de Aanbieder zich het recht voor de toegang tot het platform te blokkeren.',
  'legal.terms.section8.title': '8. Slotbepalingen',
  'legal.terms.section8.content':
    'Zwitsers recht is van toepassing. Plaats van jurisdictie is Zürich, Zwitserland. Mocht een individuele bepaling van deze Voorwaarden ongeldig zijn, dan blijft de geldigheid van de overige bepalingen ongewijzigd.',
  'legal.terms.contact.title': 'Vragen over de Voorwaarden?',
  'legal.terms.contact.content':
    'Als u vragen heeft over deze Algemene Voorwaarden, neem dan contact met ons op via:',

  // Privacybeleid Pagina
  'legal.privacy.title': 'Privacybeleid',
  'legal.privacy.section1.title': '1. Verantwoordelijke voor de gegevensverwerking',
  'legal.privacy.section1.content':
    'De verantwoordelijke voor de gegevensverwerking op deze website is NicheFinder, Zürich, Zwitserland. Wij nemen de bescherming van uw persoonlijke gegevens zeer serieus en behandelen uw persoonlijke gegevens vertrouwelijk en in overeenstemming met de wettelijke voorschriften voor gegevensbescherming.',
  'legal.privacy.section2.title': '2. Verzamelde Gegevens',
  'legal.privacy.section2.content':
    'Wij verzamelen en verwerken de volgende persoonlijke gegevens:',
  'legal.privacy.section2.item1':
    'Registratiegegevens: Naam, e-mailadres, wachtwoord (versleuteld)',
  'legal.privacy.section2.item2':
    'Gebruiksgegevens: IP-adres, browsertype, toegangstijden',
  'legal.privacy.section2.item3':
    'Bedrijfsideeën en niche-query\'s (anoniem opgeslagen)',
  'legal.privacy.section2.item4':
    'Betalingsinformatie (via beveiligde derde partijen)',
  'legal.privacy.section3.title': '3. Doel van de Gegevensverwerking',
  'legal.privacy.section3.content':
    'Uw gegevens worden voor de volgende doeleinden gebruikt:',
  'legal.privacy.section3.item1':
    'Levering en verbetering van onze AI-diensten',
  'legal.privacy.section3.item2':
    'Accountbeheer en authenticatie',
  'legal.privacy.section3.item3':
    'Facturatie en betalingsverwerking',
  'legal.privacy.section4.title': '4. Gegevensbeveiliging',
  'legal.privacy.section4.content':
    'Wij implementeren technische en organisatorische beveiligingsmaatregelen om uw gegevens te beschermen tegen manipulatie, verlies, vernietiging of ongeoorloofde toegang. Alle gegevensoverdrachten worden versleuteld via SSL/TLS.',
  'legal.privacy.section5.title': '5. Vertrouwelijkheid van Uw Bedrijfsideeën',
  'legal.privacy.section5.content':
    'Uw ingediende bedrijfsideeën en niche-query\'s worden strikt vertrouwelijk behandeld. Ze worden niet gedeeld met derden, niet gebruikt voor trainingsdoeleinden en kunnen op verzoek volledig worden verwijderd. Uw ideeën blijven van u.',
  'legal.privacy.section6.title': '6. Uw Rechten',
  'legal.privacy.section6.content':
    'U heeft de volgende rechten met betrekking tot uw persoonlijke gegevens:',
  'legal.privacy.section6.item1': 'Recht op inzage van opgeslagen gegevens',
  'legal.privacy.section6.item2': 'Recht op rectificatie van onjuiste gegevens',
  'legal.privacy.section6.item3': 'Recht op verwijdering van uw gegevens',
  'legal.privacy.section6.item4': 'Recht op gegevensoverdraagbaarheid',
  'legal.privacy.section7.title': '7. Cookies',
  'legal.privacy.section7.content':
    'Onze website gebruikt alleen technisch noodzakelijke cookies voor authenticatie en sessiebeheer. Wij gebruiken geen trackingcookies of analysetools van derden zonder uw expliciete toestemming.',
  'legal.privacy.section8.title': '8. Wijzigingen in dit Privacybeleid',
  'legal.privacy.section8.content':
    'Wij behouden ons het recht voor om dit privacybeleid aan te passen aan gewijzigde wettelijke vereisten of bij wijzigingen in de dienst. De huidige versie is altijd op deze pagina te vinden.',
  'legal.privacy.contact.title': 'Vragen over Privacy?',
  'legal.privacy.contact.content':
    'Als u vragen heeft over de verwerking van uw persoonlijke gegevens, neem dan contact met ons op via:',

  'auth.passwordStrength.label': 'Wachtwoordsterkte',
  'auth.passwordStrength.weak': 'Zwak',
  'auth.passwordStrength.medium': 'Gemiddeld',
  'auth.passwordStrength.strong': 'Sterk',
  'auth.passwordStrength.veryStrong': 'Zeer sterk',
  'auth.passwordStrength.minLength': 'Min. 8 tekens',
  'auth.passwordStrength.uppercase': 'Hoofdletter',
  'auth.passwordStrength.number': 'Cijfer',
  'auth.passwordStrength.special': 'Speciaal teken',

  trial: {
    subtitle: 'Gratis Proefperiode',
    upgrade: 'Nu Upgraden',
    creditsRemaining: 'credits resterend',
    inputHint: 'Proefversie - Geen gespreksgeschiedenis beschikbaar',
    banner: {
      title: '7-Dagen Proefperiode Actief',
      remaining: '{{days}} dagen resterend',
      credits: 'credits beschikbaar',
      upgradeNow: 'Nu Upgraden',
    },
    welcome: {
      title: 'Welkom bij de Gratis Proefperiode!',
      desc: 'Test onze AI-assistent 7 dagen gratis met 100 credits. Stel vragen en ontdek de mogelijkheden!',
    },
    info: {
      title: 'Proefperiode Beperkingen',
      credits: '100 credits voor 7 dagen',
      noHistory: 'Geen gespreksgeschiedenis',
      noSettings: 'Beperkte functies',
      upgrade: 'Upgrade voor alle functies',
    },
  },

  // ─── Instellingen Pagina ────────────────────────────────────────────────────────────
  'settings.title': 'Instellingen',
  'settings.subtitle': 'Beheer uw account en voorkeuren',
  'settings.backToOverview': 'Terug naar overzicht',
  'settings.subscriptionLink': 'Abonnement & Facturatie',
  'settings.saved': 'Wijzigingen succesvol opgeslagen',
  'settings.changesSaved': 'Wijzigingen opgeslagen',
  'settings.saveChanges': 'Wijzigingen opslaan',
  'settings.dataExported': 'Gegevens succesvol geëxporteerd',

  // Tabbladen
  'settings.tabs.profile': 'Profiel',
  'settings.tabs.preferences': 'Voorkeuren',
  'settings.tabs.notifications': 'Meldingen',
  'settings.tabs.account': 'Account & Plan',

  // Profiel
  'settings.profile.changePhoto': 'Wijzig foto',
  'settings.profile.photoHint': 'JPG, PNG of GIF (max. 2MB)',
  'settings.profile.uploading': 'Uploaden...',
  'settings.profile.photoUpdated': 'Profiel foto bijgewerkt!',
  'settings.profile.name': 'Naam',
  'settings.profile.email': 'E-mail',
  'settings.profile.phone': 'Telefoon',
  'settings.profile.changePassword': 'Wachtwoord wijzigen',
  'settings.profile.currentPassword': 'Huidig wachtwoord',
  'settings.profile.newPassword': 'Nieuw wachtwoord',
  'settings.profile.confirmPassword': 'Bevestig wachtwoord',

  // Voorkeuren
  'settings.preferences.language': 'Taal',
  'settings.preferences.chooseLanguage': 'Kies taal',
  'settings.preferences.timezone': 'Tijdzone',
  'settings.preferences.currency': 'Valuta',

  // Meldingen
  'settings.notifications.emailTitle': 'E-mailmeldingen',
  'settings.notifications.email.analysis': 'Analyse voltooid',
  'settings.notifications.email.analysisDesc': 'Ontvang een e-mail wanneer uw analyse gereed is',
  'settings.notifications.email.credits': 'Creditupdates',
  'settings.notifications.email.creditsDesc': 'Meldingen over credits en resets',
  'settings.notifications.email.billing': 'Facturen & Betalingen',
  'settings.notifications.email.billingDesc': 'Meldingen over facturen en planwijzigingen',
  'settings.notifications.email.newsletter': 'Nieuwsbrief',
  'settings.notifications.email.newsletterDesc': 'Tips, updates en nieuwe functies',
  'settings.notifications.pushTitle': 'Pushmeldingen',
  'settings.notifications.push.analysis': 'Analyse voltooid',
  'settings.notifications.push.analysisDesc': 'Browsermelding wanneer analyse gereed is',
  'settings.notifications.push.credits': 'Creditwaarschuwingen',
  'settings.notifications.push.creditsDesc': 'Waarschuwing wanneer creditsaldo laag is',

  // Account
  'settings.account.currentSubscription': 'Huidig Abonnement',
  'settings.account.plan': 'Plan',
  'settings.account.price': 'Prijs',
  'settings.account.nextBilling': 'Volgende facturatie',
  'settings.account.manageSubscription': 'Beheer abonnement en betalingen',
  'settings.account.dataPrivacy': 'Gegevens & Privacy',
  'settings.account.exportData': 'Exporteer gegevens',
  'settings.account.deleteAccount': 'Verwijder account',

  // Verwijder Modaal
  'settings.deleteModal.title': 'Account verwijderen?',
  'settings.deleteModal.subtitle': 'Alle gegevens worden permanent verwijderd.',
  'settings.deleteModal.warning1': 'Alle analyses en gegevens worden verwijderd',
  'settings.deleteModal.warning2': 'Actief abonnement wordt onmiddellijk geannuleerd',
  'settings.deleteModal.warning3': 'Geen restitutie mogelijk',
  'settings.deleteModal.confirmLabel': 'Typ "{{word}}" om te bevestigen *',
  'settings.deleteModal.cancel': 'Annuleren',
  'settings.deleteModal.confirm': 'Verwijder account',

  // ─── Abonnement & Facturatie ─────────────────────────────────────────────
  'sub.backToOverview': 'Terug naar overzicht',
  'sub.settings': 'Instellingen',
  'sub.title': 'Abonnement & Facturatie',
  'sub.subtitle': 'Beheer uw abonnement, betaalmethoden en facturen',
  'sub.tab.overview': 'Overzicht',
  'sub.tab.payment': 'Betaalmethoden',
  'sub.tab.billing': 'Factuuradres',
  'sub.tab.history': 'Betalingsgeschiedenis',
  'sub.memberSince': 'Lid sinds',
  'sub.perMonth': 'per maand',
  'sub.baseCHF': '(CHF {{amount}} basis)',
  'sub.nextBilling': 'Volgende facturatie',
  'sub.creditsUsed': 'Credits gebruikt',
  'sub.paymentMethod': 'Betaalmethode',
  'sub.creditUsage': 'Creditgebruik',
  'sub.changePlan': 'Wijzig plan',
  'sub.reactivate': 'Reactiveren',
  'sub.cancelSub': 'Abonnement opzeggen',
  'sub.manageCards': 'Beheer kaarten',
  'sub.downloadInvoices': 'Download facturen',
  'sub.invoicesAvailable': '{{count}} facturen beschikbaar als PDF',
  'sub.accountSettings': 'Accountinstellingen',
  'sub.profileNotifications': 'Profiel, meldingen en meer',
  // Prijzen in EUR info
  'sub.eurInfo': 'Prijzen getoond in',
  'sub.eurLabel': 'Euro',
  'sub.eurRate': 'Koers:',
  'sub.currentRate': 'Huidige koers',
  // Betaalmethoden
  'sub.savedCards': 'Opgeslagen Kaarten',
  'sub.newCard': 'Nieuwe Kaart',
  'sub.default': 'Standaard',
  'sub.setDefault': 'Als standaard instellen',
  'sub.validUntil': 'Geldig tot',
  'sub.noCards': 'Geen kaarten opgeslagen',
  'sub.addFirstCard': 'Voeg eerste kaart toe',
  'sub.securePayments': 'Veilige Betalingen',
  'sub.securePaymentsDesc': 'Alle betaalgegevens worden versleuteld en veilig opgeslagen bij onze betalingsprovider. Wij slaan geen volledige kaartnummers op.',
  // Factuuradres
  'sub.billingAddress': 'Factuuradres',
  'sub.edit': 'Bewerken',
  'sub.name': 'Naam',
  'sub.streetAddress': 'Straat & Nummer',
  'sub.zip': 'Postcode',
  'sub.city': 'Plaats',
  'sub.country': 'Land',
  'sub.address': 'Adres',
  'sub.save': 'Opslaan',
  'sub.cancel': 'Annuleren',
  'sub.country.switzerland': 'Zwitserland',
  'sub.country.germany': 'Duitsland',
  'sub.country.austria': 'Oostenrijk',
  'sub.country.netherlands': 'Nederland',
  'sub.country.belgium': 'België',
  // Betalingsgeschiedenis
  'sub.paymentHistory': 'Betalingsgeschiedenis',
  'sub.allInvoicesPDF': 'Download alle facturen als PDF met logo',
  'sub.downloadAll': 'Download alle',
  'sub.eurInvoiceNote': 'Facturen worden altijd in CHF uitgereikt. Getoonde EUR-bedragen zijn ter referentie.',
  'sub.date': 'Datum',
  'sub.description': 'Beschrijving',
  'sub.net': 'Netto',
  'sub.vat': 'BTW',
  'sub.total': 'Totaal',
  'sub.status': 'Status',
  'sub.pdf': 'PDF',
  'sub.invoices': 'facturen',
  'sub.totalAmount': 'Totaalbedrag',
  // Wijzig Plan Modaal
  'sub.changePlanTitle': 'Wijzig Plan',
  'sub.current': 'Huidig',
  'sub.month': '/maand',
  'sub.showLess': 'Minder tonen',
  'sub.showMore': '+{{count}} meer',
  'sub.switchPlan': 'Wissel van plan',
  'sub.eurPriceNote': 'Prijzen getoond in EUR ({{note}}). Facturatie is in CHF.',
  // Annuleer Modaal
  'sub.cancelTitle': 'Abonnement echt opzeggen?',
  'sub.cancelIrreversible': 'Deze actie kan niet ongedaan worden gemaakt.',
  'sub.cancelWarning1': 'Alle resterende credits vervallen',
  'sub.cancelWarning2': 'Degradatie naar Gratis Plan',
  'sub.cancelWarning3': 'Verlies van alle premiumfuncties',
  'sub.pauseInstead': 'Alternatief: Abonnement pauzeren?',
  'sub.pauseDesc': 'Pauzeer uw abonnement in plaats daarvan en behoud uw gegevens.',
  'sub.preferPause': 'Pauzeer liever',
  'sub.cancelReason': 'Reden van opzegging',
  'sub.selectReason': 'Selecteer...',
  'sub.reason.tooExpensive': 'Te duur',
  'sub.reason.notUsing': 'Gebruik het niet genoeg',
  'sub.reason.missingFeatures': 'Ontbrekende functies',
  'sub.reason.foundAlternative': 'Alternatief gevonden',
  'sub.reason.other': 'Anders',
  'sub.confirmType': 'Bevestiging: Typ "CANCEL" *',
  'sub.cancelNow': 'Nu opzeggen',
  // Voeg Kaart Modaal
  'sub.addCardTitle': 'Nieuwe Kaart Toevoegen',
  'sub.cardHolder': 'Kaarthouder *',
  'sub.cardNumber': 'Kaartnummer *',
  'sub.expiryDate': 'Vervaldatum *',
  'sub.addCard': 'Kaart toevoegen',
  // Wijzig Kaart Modaal
  'sub.choosePayment': 'Kies betaalmethode',
  'sub.active': 'Actief',
  'sub.close': 'Sluiten',
  // Toast berichten
  'sub.toast.cancelled': 'Uw abonnement is geannuleerd aan het einde van de factureringsperiode.',
  'sub.toast.reactivated': 'Uw abonnement is succesvol gereactiveerd!',
  'sub.toast.planChanged': 'Plan succesvol gewijzigd naar {{plan}}!',
  'sub.toast.defaultChanged': 'Standaard betaalmethode gewijzigd.',
  'sub.toast.cannotDeleteDefault': 'De standaardkaart kan niet worden verwijderd.',
  'sub.toast.cardRemoved': 'Kaart is verwijderd.',
  'sub.toast.fillAll': 'Vul alle velden in.',
  'sub.toast.cardAdded': 'Nieuwe kaart succesvol toegevoegd!',
  'sub.toast.billingSaved': 'Factuuradres opgeslagen.',
  'sub.toast.invoiceDownloaded': 'Factuur {{id}} gedownload!',
  'sub.toast.pdfError': 'Fout bij het maken van PDF.',
  // Chat interface
  'sub.notEnoughCredits': 'Niet genoeg credits',
  'sub.needCredits': 'U heeft minimaal {{count}} credits per vraag nodig.',
  'sub.creditsLow': 'Credits bijna op',
  'sub.questionsLeft': '{{count}} vragen mogelijk.',
  'sub.plan': 'Plan',
  'sub.base': 'basis',
  'sub.unlimited': 'Ongelimiteerd',
  'sub.status.active': 'Actief',
  'sub.status.cancelled': 'Geannuleerd',
  'sub.status.paused': 'Gepauzeerd',
  'sub.invoice': 'FACTUUR',
  'sub.from': 'VAN',
  'sub.to': 'AAN',
  'sub.vatId': 'BTW-nummer',
  'sub.tel': 'Tel',
  'sub.invoiceDate': 'Factuurdatum',
  'sub.invoiceNumber': 'Factuurnummer',
  'sub.paymentStatus': 'Betalingsstatus',
  'sub.creditCard': 'Creditcard',
  'sub.quantity': 'AANTAL',
  'sub.price': 'PRIJS',
  'sub.amount': 'BEDRAG',
  'sub.subtotal': 'Subtotaal',
  'sub.bank': 'Bank',
  'sub.card': 'Kaart',
  'sub.cvc': 'CVC',
  'sub.cardHolderPlaceholder': 'Jan Jansen',

  // ─── Admin Paneel ─────────────────────────────────────────────────────────────
  'admin.title': 'Admin Dashboard',
  'admin.subtitle': 'Controlecentrum',
  'admin.superAdmin': 'Super Admin',
  'admin.logout': 'Uitloggen',
  'admin.tabs.users': 'Gebruikersbeheer',
  'admin.tabs.downgrades': 'Degradaties',
  'admin.tabs.tips': 'Tip van de Dag',
  'admin.tabs.coupons': 'Couponcodes',
  'admin.tabs.website': 'Website Editor',
  'admin.tabs.ai': 'AI Instellingen',
  'admin.tabs.transactions': 'Transactielogboek',
  'admin.tabs.stats': 'Statistieken',
  'admin.users.searchPlaceholder': 'Zoek gebruikers (e-mail of naam)...',
  'admin.users.manageSubscription': 'Abonnement beheren',
  'admin.users.grantFree': 'Gratis account toekennen',
  'admin.users.blockUser': 'Blokkeer gebruiker',
  'admin.users.cancellationPlaceholder': 'Waarom wordt het abonnement geannuleerd?',
  'admin.users.selectPlan': 'Selecteer plan',
  'admin.users.subChanged': 'Abonnement van {{name}} gewijzigd naar {{plan}}',
  'admin.users.noReasonGiven': 'Geen reden opgegeven',
  'admin.users.subCancelled': 'Abonnement van {{name}} geannuleerd (geldig tot {{date}})',
  'admin.users.paused': 'Gepauzeerd',
  'admin.users.subPaused': 'Abonnement van {{name}} is gepauzeerd',
  'admin.users.subReactivated': 'Abonnement van {{name}} is gereactiveerd',
  'admin.users.freeAccount': 'Gratis Account',
  'admin.users.blocked': 'Geblokkeerd',
  'admin.users.cancelledExpiring': 'Geannuleerd (verloopt)',
  'admin.users.cancelledOn': 'Geannuleerd:',
  'admin.users.endsOn': 'Eindigt:',
  'admin.users.daysRemaining': 'dagen resterend',
  'admin.users.expired': '(Verlopen)',
  'admin.users.total': 'Totaal:',
  'admin.users.usersLabel': 'gebruikers',
  'admin.users.free': 'gratis',
  'admin.users.block': 'Blokkeer',
  'admin.users.unblock': 'Deblokkeer',
  'admin.users.unblockUser': 'Deblokkeer gebruiker',
  'admin.users.selectAction': 'Selecteer actie',
  'admin.users.cancelSub': 'Annuleer abonnement',
  'admin.users.cancelSubDesc': 'Annulering aan einde van de maand',
  'admin.users.pauseSub': 'Pauzeer abonnement',
  'admin.users.pauseSubDesc': 'Tijdelijke pauze',
  'admin.users.changePlan': 'Wijzig plan',
  'admin.users.changePlanDesc': 'Schakel over naar een ander plan',
  'admin.users.reactivateSub': 'Reactiver abonnement',
  'admin.users.reactivateDesc': 'Maak annulering ongedaan',
  'admin.users.alreadyCancelled': 'Abonnement reeds geannuleerd',
  'admin.users.planLabel': 'Plan',
  'admin.users.cancellationReasonOpt': 'Reden van annulering (optioneel)',
  'admin.users.cancelInfo1': 'Het abonnement eindigt op',
  'admin.users.cancelInfo2': '(einde van de maand). Tot die tijd heeft de gebruiker volledige toegang. Geen restitutie.',
  'admin.users.newPlan': 'Nieuw plan',
  'admin.users.warning': 'Waarschuwing',
  'admin.users.blockDesc': 'De gebruiker wordt onmiddellijk uitgelogd en kan niet meer inloggen. Alle actieve sessies worden beëindigd.',
  'admin.users.confirmUnblock': 'Bevestig deblokkering',
  'admin.users.unblockDesc': 'De gebruiker kan weer inloggen en alle functies gebruiken.',
  'admin.users.afterBlock': 'Na blokkering:',
  'admin.users.afterUnblock': 'Na deblokkering:',
  'admin.users.noAccountAccess': 'Geen accounttoegang',
  'admin.users.noNewAnalyses': 'Geen nieuwe analyses mogelijk',
  'admin.users.creditsStored': 'Credits en geschiedenis blijven opgeslagen',
  'admin.users.accessRestored': 'Accounttoegang hersteld',
  'admin.users.allFeaturesAvail': 'Alle functies weer beschikbaar',
  'admin.users.creditsPreserved': 'Credits en geschiedenis behouden',
  'admin.users.downgrade': 'Plan Degraderen',
  'admin.users.grantFreeBtn': 'Gratis toekennen',
  'admin.users.durationMonths': 'Duur (maanden)',
  'admin.users.months': 'maand(en)',
  'admin.users.freePlan': 'gratis',
  'admin.users.freeSummary': 'ontvangt',
  'admin.users.withCredits': 'met',
  'admin.users.credits': 'Credits',
  'admin.users.subInfo': 'Abonnementsinformatie',
  'admin.users.currentPlan': 'Huidig Plan',
  'admin.users.joined': 'Lid geworden',
  'admin.users.totalSpent': 'Totaal Besteed',
  'admin.users.paymentMethod': 'Betaalmethode',
  'admin.users.validThrough': 'Geldig tot',
  'admin.users.billingAddress': 'Factuuradres',
  'admin.users.transactionHistory': 'Transactiegeschiedenis',
  'admin.users.cancellationDate': 'Annuleringsdatum',
  'admin.users.validUntil': 'Geldig tot (einde maand)',
  'admin.users.cancellationReason': 'Annuleringsreden',
  'admin.users.noReason': 'Geen reden opgegeven',
  'admin.users.timeRemaining': 'Resterende tijd',
  'admin.users.daysUntilDeactivation': 'dagen tot deactivering',
  'admin.table.user': 'Gebruiker',
  'admin.table.plan': 'Plan',
  'admin.table.subStatus': 'Abonnementsstatus',
  'admin.table.cancellation': 'Annulering',
  'admin.table.payment': 'Betaalmethode',
  'admin.table.spending': 'Uitgaven',
  'admin.table.actions': 'Acties',
  'admin.actions.viewDetails': 'Bekijk details',
  'admin.actions.manageSubscription': 'Abonnement beheren',
  'admin.actions.grantFree': 'Verleen gratis toegang',
  'admin.actions.block': 'Blokkeer gebruiker',
  'admin.actions.unblock': 'Deblokkeer gebruiker',
  'admin.actions.cancel': 'Annuleren',
  'admin.actions.save': 'Opslaan',
  'admin.actions.delete': 'Verwijderen',
  'admin.actions.confirm': 'Bevestigen',
  'admin.actions.done': 'Gedaan',
  'admin.actions.edit': 'Bewerken',
  'admin.actions.close': 'Sluiten',
  'admin.table.status': 'Status',
  'admin.filter.all': 'Alle',
  'admin.subscription.active': 'Actief',
  'admin.subscription.cancelled': 'Geannuleerd',
  'admin.subscription.paused': 'Gepauzeerd',
  'admin.subscription.unknown': 'Onbekend',
  'admin.status.active': 'Actief',
  'admin.status.inactive': 'Inactief',
  'admin.status.pending': 'In behandeling',
  'admin.status.approved': 'Goedgekeurd',
  'admin.status.rejected': 'Afgewezen',
  'admin.coupons.title': 'Couponbeheer',
  'admin.coupons.subtitle': 'Creëer en beheer couponcodes',
  'admin.coupons.newCoupon': 'Nieuwe Coupon',
  'admin.coupons.registrationCoupons': 'Registratie Coupons',
  'admin.coupons.trialCoupons': 'Proeftoegang Coupons',
  'admin.coupons.type': 'Type',
  'admin.coupons.plan': 'Plan',
  'admin.coupons.value': 'Waarde',
  'admin.coupons.usage': 'Gebruik',
  'admin.coupons.validUntil': 'Geldig tot',
  'admin.coupons.created': 'Gemaakt',
  'admin.coupons.actions': 'Acties',
  'admin.coupons.copyCode': 'Kopieer code',
  'admin.coupons.allPlans': 'Alle Plannen',
  'admin.coupons.discount': 'Korting',
  'admin.coupons.days': 'dagen',
  'admin.coupons.months': 'maanden',
  'admin.coupons.free': 'gratis',
  'admin.coupons.unlimited': 'Ongelimiteerd',
  'admin.coupons.createRegistration': 'Maak Registratie Coupon',
  'admin.coupons.createTrial': 'Maak Proeftoegang Coupon',
  'admin.coupons.couponCode': 'Couponcode',
  'admin.coupons.codePlaceholder': 'bv. NF-7X3K9M',
  'admin.coupons.generateCode': 'Genereer nieuwe code',
  'admin.coupons.alertFillRequired': 'Vul alle verplichte velden in',
  'admin.coupons.alertSelectExpiry': 'Selecteer een vervaldatum of schakel "Onbeperkte geldigheid" in',
  'admin.coupons.alertCreateError': 'Fout bij het aanmaken van coupon',
  'admin.coupons.confirmDelete': 'Weet u zeker dat u deze coupon wilt verwijderen?',
  'admin.coupons.discountPercent': 'Korting (%)',
  'admin.coupons.bonusCredits': 'Bonus Credits',
  'admin.coupons.freeDuration': 'Gratis Duur',
  'admin.coupons.maxUses': 'Max. Gebruik',
  'admin.coupons.expiryDate': 'Vervaldatum',
  'admin.coupons.unlimitedValidity': 'Onbeperkte geldigheid',
  'admin.coupons.unlimitedUses': 'Onbeperkt gebruik',
  'admin.coupons.trialCredits': 'Proefcredits',
  'admin.coupons.trialDuration': 'Proefduur',
  'admin.coupons.typePlaceholder': 'bv. Early Bird, Partner, Influencer',
  'admin.coupons.duration': 'Duur',
  'admin.stats.totalUsers': 'Totaal Gebruikers',
  'admin.stats.monthlyRevenue': 'Maandelijkse Omzet',
  'admin.stats.activeSubscriptions': 'Actieve Abonnementen',
  'admin.stats.average': 'Gemiddeld',
  'admin.stats.revenuePerUser': 'Omzet per Gebruiker',
  'admin.stats.grossRevenue': 'Bruto Omzet',
  'admin.stats.net': 'NETTO',
  'admin.stats.netRevenue': 'Netto Omzet',
  'admin.stats.churnRate': 'Verlooppercentage',
  'admin.stats.planDistribution': 'Planverdeling',
  'admin.stats.users': 'gebruikers',
  'admin.stats.revenueByPlan': 'Omzet per Plan',
  'admin.stats.recentActivity': 'Recente Activiteit',
  'admin.stats.activity1': 'Thomas Weber geüpgraded naar Builder',
  'admin.stats.activity2': 'Nieuwe gebruiker geregistreerd',
  'admin.stats.activity3': 'Anna Schmidt geüpgraded naar Pro',
  'admin.stats.hoursAgo2': '2 uur geleden',
  'admin.stats.hoursAgo5': '5 uur geleden',
  'admin.stats.dayAgo1': '1 dag geleden',
  'admin.stats.couponStats': 'Couponstatistieken',
  'admin.stats.totalRedemptions': 'Totaal Inwisselingen',
  'admin.stats.activeCoupons': 'Actieve Coupons',
  'admin.stats.registrationRedemptions': 'Registratie Inwisselingen',
  'admin.stats.trialRedemptions': 'Proef Inwisselingen',
  'admin.stats.couponDistribution': 'Couponverdeling',
  'admin.stats.registrationCoupons': 'Registratie Coupons',
  'admin.stats.trialCoupons': 'Proef Coupons',
  'admin.stats.expiredInactive': 'Verlopen/Inactief',
  'admin.stats.topCoupons': 'Top Coupons op Inwisselingen',
  'admin.stats.redemptions': 'inwisselingen',
  'admin.stats.noCouponsRedeemed': 'Nog geen coupons ingewisseld',
  'admin.downgrade.pending': 'in behandeling',
  'admin.downgrade.refunds': 'Restituties',
  'admin.downgrade.sectionRequests': 'Aanvragen',
  'admin.downgrade.sectionStats': 'Statistieken',
  'admin.downgrade.sectionRules': 'Regels',
  'admin.downgrade.pendingRequests': 'Openstaande Aanvragen',
  'admin.downgrade.approvedRequests': 'Goedgekeurde Aanvragen',
  'admin.downgrade.rejectedRequests': 'Afgewezen Aanvragen',
  'admin.downgrade.activeRules': 'Actieve Regels',
  'admin.downgrade.autoRules': 'Automatische Degradatieregels',
  'admin.downgrade.autoRulesDesc': 'Creëer regels die automatisch degradaties activeren op basis van gebruiksgedrag',
  'admin.downgrade.newRule': 'Nieuwe Regel',
  'admin.downgrade.totalRules': 'Totaal Regels',
  'admin.downgrade.triggeredActions': 'Geactiveerde Acties',
  'admin.downgrade.conditionsAnd': 'Voorwaarden (AND gekoppeld)',
  'admin.downgrade.action': 'Actie',
  'admin.downgrade.successTitle': 'Degradatie succesvol!',
  'admin.downgrade.successDesc': 'De gebruiker is succesvol gedegradeerd en de restitutie is verwerkt.',
  'admin.downgrade.closing': 'Afsluiten...',
  'admin.downgrade.title': 'Degradeer Gebruiker',
  'admin.downgrade.currentPlan': 'Huidig Plan',
  'admin.downgrade.spending': 'Uitgaven',
  'admin.downgrade.availablePlans': 'Beschikbare Plannen voor Degradatie',
  'admin.downgrade.perMonth': 'per maand',
  'admin.downgrade.refundCalc': 'Restitutieberekening',
  'admin.downgrade.currentPlanLabel': 'Huidig Plan',
  'admin.downgrade.newPlan': 'Nieuw Plan',
  'admin.downgrade.remainingDays': 'Resterende Dagen',
  'admin.downgrade.daysOf': '15 van 30 dagen',
  'admin.downgrade.proRataRefund': 'Pro-rata Restitutie',
  'admin.downgrade.importantNote': 'Belangrijke Notitie',
  'admin.downgrade.warningDesc': 'De degradatie wordt onmiddellijk uitgevoerd. De gebruiker verliest toegang tot premiumfuncties en overtollige credits worden verwijderd.',
  'admin.downgrade.processing': 'Verwerken...',
  'admin.downgrade.execute': 'Voer Degradatie Uit',
  'admin.downgrade.notification': 'Melding',
  'admin.downgrade.noNotification': 'Geen Melding',
  'admin.downgrade.daysPeriod': 'dagen respijtperiode',
  'admin.downgrade.created': 'Gemaakt:',
  'admin.downgrade.triggered': 'geactiveerd',
  'admin.downgrade.noRules': 'Nog geen regels aangemaakt',
  'admin.downgrade.createFirstRule': 'Maak eerste regel',
  'admin.downgrade.editRule': 'Bewerk Regel',
  'admin.downgrade.createRule': 'Maak Nieuwe Regel',
  'admin.downgrade.ruleName': 'Regelnaam',
  'admin.downgrade.description': 'Beschrijving',
  'admin.downgrade.allConditions': 'Voorwaarden (allemaal moeten worden voldaan)',
  'admin.downgrade.addCondition': 'Voeg voorwaarde toe',
  'admin.downgrade.type': 'Type',
  'admin.downgrade.value': 'Waarde',
  'admin.downgrade.fromPlan': 'Van plan',
  'admin.downgrade.toPlan': 'Naar plan',
  'admin.condition.inactivity': 'Inactiviteit',
  'admin.condition.creditUsage': 'Creditgebruik',
  'admin.condition.loginFrequency': 'Inlogfrequentie',
  'admin.condition.featureUsage': 'Functiegebruik',
  'admin.condition.supportTickets': 'Support Tickets',
  'admin.operator.lessThan': 'minder dan',
  'admin.operator.greaterThan': 'meer dan',
  'admin.operator.equals': 'precies',
  'admin.operator.between': 'tussen',
  'admin.unit.days': 'dagen',
  'admin.unit.perMonth': 'per maand',
  'admin.unit.count': 'aantal',
  'admin.transactions.all': 'Alle Transacties',
  'admin.transactions.allCards': 'Alle Kaarten',
  'admin.transactions.notFound': 'Geen transacties gevonden',
  'admin.transactions.totalLabel': 'Totaal',
  'admin.transactions.transactions': 'transacties',
  'admin.tips.title': 'Tip van de Dag',
  'admin.tips.subtitle': 'Creëer en beheer tips die aan alle gebruikers worden getoond',
  'admin.tips.active': 'Actief',
  'admin.tips.currentlyShown': 'Deze tip wordt momenteel aan alle gebruikers getoond',
  'admin.tips.createNew': 'Nieuwe Tip Maken',
  'admin.tips.generating': 'Genereren...',
  'admin.tips.generateAI': 'Genereer AI Tip',
  'admin.tips.titleLabel': 'Titel',
  'admin.tips.titlePlaceholder': 'bv. Tip van de Dag',
  'admin.tips.category': 'Categorie',
  'admin.tips.categoryTip': 'Tip',
  'admin.tips.categoryFeature': 'Nieuwe Functie',
  'admin.tips.categoryProductivity': 'Productiviteit',
  'admin.tips.categoryUpdate': 'Update',
  'admin.tips.content': 'Inhoud',
  'admin.tips.contentPlaceholder': 'Schrijf uw tip voor gebruikers hier...',
  'admin.tips.addTip': 'Tip Toevoegen',
  'admin.tips.allTips': 'Alle Tips',
  'admin.tips.noTips': 'Nog geen tips aangemaakt',
  'admin.tips.noTipsHint': 'Klik op "Genereer AI Tip" om te beginnen',
  'admin.noData': 'Geen gegevens beschikbaar',
  'admin.range.7d': '7 dagen',
  'admin.range.30d': '30 dagen',
  'admin.range.90d': '90 dagen',
  'admin.range.1y': '1 jaar',
  'admin.actions.saveSettings': 'Instellingen opslaan',
  'admin.actions.create': 'Creëren',
  'admin.downgrade.sectionReports': 'Rapporten',
  'admin.downgrade.settings': 'Degradatie Instellingen',
  'admin.downgrade.autoApprove': 'Automatische Goedkeuring',
  'admin.downgrade.autoApproveDesc': 'Keur degradatieverzoeken automatisch goed',
  'admin.downgrade.refundPolicy': 'Restitutiebeleid',
  'admin.downgrade.prorata': 'Pro-rata restitutie',
  'admin.downgrade.prorataDesc': 'Proportionele restitutie op basis van resterende dagen',
  'admin.downgrade.fullRefund': 'Volledige restitutie',
  'admin.downgrade.fullRefundDesc': 'Volledige terugbetaling van het prijsverschil',
  'admin.downgrade.noRefund': 'Geen restitutie',
  'admin.downgrade.noRefundDesc': 'Degradatie zonder restitutie',
  'admin.downgrade.daysRemaining15': '(met 15 resterende dagen)',
  'admin.downgrade.requestsTitle': 'Degradatieverzoeken',
  'admin.downgrade.approvalRate': 'Goedkeuringspercentage',
  'admin.downgrade.mostCommonTransition': 'Meest voorkomende overgang',
  'admin.downgrade.mostCommonReason': 'Meest voorkomende reden',
  'admin.downgrade.avgProcessingTime': 'Gem. verwerkingstijd',
  'admin.downgrade.avgTimeDesc': 'Gemiddelde tijd tot beslissing',
  'admin.downgrade.totalRefunds': 'Totaal Restituties',
  'admin.downgrade.pendingRefunds': 'Openstaande Restituties',
  'admin.downgrade.summary': 'Samenvatting',
  'admin.downgrade.total': 'Totaal',
  'admin.downgrade.csvDesc': 'Voor Excel, Google Sheets',
  'admin.downgrade.downloadCSV': 'Download als CSV',
  'admin.downgrade.jsonDesc': 'Voor ontwikkelaars, API\'s',
  'admin.downgrade.downloadJSON': 'Download als JSON',
  'admin.downgrade.exportInfo': 'De export bevat',
  'admin.downgrade.entries': 'vermeldingen uit de geselecteerde periode',
  'admin.downgrade.topReasons': 'Meest voorkomende degradatieredenen',
  'admin.downgrade.refundHistory': 'Restitutiegeschiedenis',
  'admin.downgrade.noRefunds': 'Nog geen restituties',
  'admin.downgrade.statistics': 'Degradatiestatistieken',
  'admin.downgrade.requests': 'Aanvragen',
  'admin.downgrade.monthlyTrend': 'Maandelijkse Trend',
  'admin.downgrade.planTransitions': 'Planovergangen',
  'admin.downgrade.trend': 'Trend (vs. vorige maand)',
  'admin.downgrade.trendDesc': 'Minder degradaties = beter',
  'admin.coupons.allPlansUniversal': 'Alle Plannen (Universeel)',
  'admin.coupons.onlyStarter': 'Alleen Starter',
  'admin.coupons.onlyPro': 'Alleen Pro',
  'admin.coupons.onlyBuilder': 'Alleen Builder',
  'admin.coupons.allPlansHint': 'Kies "Alle Plannen" voor een universele coupon',
  'admin.coupons.discountOptional': 'Korting % (optioneel)',
  'admin.coupons.discountPlaceholder': 'bv. 50 voor 50% korting',
  'admin.coupons.bonusCreditsOptional': 'Bonus Credits (optioneel)',
  'admin.coupons.bonusCreditsPlaceholder': 'bv. 500',
  'admin.coupons.freeDurationOptional': 'Gratis Duur (optioneel)',
  'admin.coupons.durationPlaceholder': 'bv. 30',
  'admin.coupons.freeDurationHint': 'bv. 30 dagen gratis te gebruiken',
  'admin.coupons.noLimit': 'Geen gebruiksbeperking',
  'admin.coupons.noExpiry': 'Geen vervaldatum',
  'admin.coupons.creditsPlaceholder': 'bv. 100',
  'admin.coupons.creditsHint': 'Aantal credits voor de proeftoegang',
  'admin.coupons.trialDurationHint': 'Hoe lang de proeftoegang geldig is',
  'admin.coupons.autoCalculated': 'Automatisch berekend op basis van proefduur',
  'admin.websiteEditor.title': 'Website Editor',
  'admin.websiteEditor.subtitle': 'Bewerk alle secties van de startpagina',
  'admin.websiteEditor.openPreview': 'Open Voorbeeld',
  'admin.websiteEditor.group.structure': 'Pagina Structuur',
  'admin.websiteEditor.group.design': 'Ontwerp & Lay-out',
  'admin.websiteEditor.group.settings': 'Instellingen',
  'admin.websiteEditor.tab.navbar': 'Navigatie',
  'admin.websiteEditor.tab.howitworks': 'Hoe Het Werkt',
  'admin.websiteEditor.tab.about': 'Over Ons',
  'admin.websiteEditor.tab.pricing': 'Prijzen',
  'admin.websiteEditor.tab.sections': 'Secties',
  'admin.websiteEditor.tab.media': 'Media',
  'admin.websiteEditor.tab.chatwidget': 'Praat met Ons',
  'admin.websiteEditor.tab.invoice': 'Facturen',
  'admin.websiteEditor.tab.legal': 'Juridisch',
  'admin.websiteEditor.tab.seo': 'Basis SEO',
  'admin.websiteEditor.tab.advancedseo': 'Geavanceerde SEO',
  'admin.websiteEditor.tab.versions': 'Versies',
  'admin.hero.title': 'Bewerk Hero Sectie',
  'admin.hero.subtitle': 'Teksten, knoppen en statistieken van de startpagina',
  'admin.hero.reset': 'Reset',
  'admin.hero.save': 'Opslaan',
  'admin.hero.savedMsg': 'Hero-gegevens opgeslagen!',
  'admin.hero.badge': 'Badge Tekst',
  'admin.hero.headings': 'Koppen',
  'admin.hero.line1White': 'Regel 1 (wit)',
  'admin.hero.line2Gold': 'Regel 2 (goud)',
  'admin.hero.subtitleSection': 'Subtitel',
  'admin.hero.line1': 'Regel 1',
  'admin.hero.line2': 'Regel 2',
  'admin.hero.buttons': 'Knoppen',
  'admin.hero.primaryBtn': 'Primaire Knop (goud)',
  'admin.hero.secondaryBtn': 'Secundaire Knop (rand)',
  'admin.hero.stats': 'Statistieken',
  'admin.hero.statN': 'Statistiek {{n}}',
  'admin.hero.value': 'Waarde',
  'admin.hero.label': 'Label',
  'admin.hero.previewNote': 'Wijzigingen zijn zichtbaar op de startpagina na opslaan. Herlaad de pagina om de preview te zien.',

  // Idee Geschiedenis
  'history.title': 'Idee Geschiedenis',
  'history.countLabel': '{{count}} analyses',
  'history.recentLabel': 'Uw recente analyses',
  'history.exportAll': 'Exporteer alle',
  'history.metrics.marketSize': 'Marktomvang',
  'history.metrics.competition': 'Concurrentie',
  'history.metrics.startingCapital': 'Startkapitaal',
  'history.metrics.timeToMarket': 'Tijd tot Marktintroductie',
  'history.metrics.profitPotential': 'Winstpotentieel',
  'history.metrics.scalability': 'Schaalbaarheid',
  'history.summary.title': 'Samenvatting',
  'history.download': 'Download',
  'history.downloadJSON': 'Opslaan als JSON',
  'history.downloadTXT': 'Opslaan als TXT',
  'history.downloadPDF': 'Opslaan als PDF',
  'history.fullAnalysis': 'Volledige Analyse',
  'history.searchPlaceholder': 'Zoek op titel of tags...',
  'history.filterAll': 'Alle beoordelingen',
  'history.loading': 'Laden van analyses...',
  'history.noResults': 'Geen resultaten gevonden',
  'history.empty': 'Nog geen analyses',
  'history.emptyHint': 'Start een analyse in de AI Assistent',
  'history.delete': 'Verwijderen',
  'history.cancel': 'Annuleren',
  'history.deleteModalTitle': 'Analyse verwijderen?',
  'history.deleteModalDesc': '"{{title}}" wordt permanent verwijderd.',
  'history.errorLoading': 'Fout bij laden analyses',
  'history.deleteSuccess': 'Analyse succesvol verwijderd',
  'history.deleteError': 'Fout bij verwijderen analyse',
  'history.jsonExported': 'JSON geëxporteerd',
  'history.txtExported': 'TXT geëxporteerd',
  'history.allExported': '{{count}} ideeën geëxporteerd',
  'history.analysisHeader': 'IDEE ANALYSE',
  'history.titleLabel': 'Titel',
  'history.ratingLabel': 'Beoordeling',
  'history.dateLabel': 'Datum',
  'history.creditsLabel': 'Credits',
  'history.analysisSection': 'Analyse',

  // Overzicht
  'overview.title': 'Overzicht',
  'overview.last24h': 'Laatste 24 uur',
  'overview.analysesToday': 'Analyses vandaag',
  'overview.totalAnalyses': 'Totaal analyses',
  'overview.successRate': 'Succespercentage',
  'overview.topRatings': 'Top beoordelingen',
  'overview.recentActivity': 'Recente activiteit',
  'overview.viewAll': 'Bekijk alle',
  'overview.quickAccess': 'Snelle toegang',
  'overview.quick.newAnalysis': 'Start nieuwe analyse',
  'overview.quick.newAnalysisDesc': 'Start een nieuwe AI-gestuurde niche-analyse',
  'overview.quick.myAnalyses': 'Mijn analyses',
  'overview.quick.myAnalysesDesc': 'Bekijk alle eerdere analyses',
  'overview.quick.buyCredits': 'Koop credits',
  'overview.quick.buyCreditsDesc': 'Meer credits voor meer analyses',
  'overview.quick.settings': 'Instellingen',
  'overview.quick.settingsDesc': 'Pas profiel en voorkeuren aan',
  'overview.unlimitedCredits': 'Ongelimiteerde credits beschikbaar',
  'overview.creditsAvailable': 'credits beschikbaar',
  'overview.upgradePlan': 'Upgrade plan',
  'overview.buyCredits': 'Koop credits',
  'overview.creditUsage': 'Creditgebruik deze maand',
  'overview.available': 'beschikbaar',

  // --- Admin Nieuwe Sleutels ---
  'admin.transactions.upgrades': 'Upgrades',
  'admin.transactions.downgrades': 'Degradaties',
  'admin.transactions.visa': 'Visa',
  'admin.transactions.mastercard': 'Mastercard',
  'admin.transactions.amex': 'Amex',
  
  'admin.users.grantFreeSuccess': '{{name}} heeft nu {{months}} maand(en) gratis {{plan}} plan',
  'admin.users.blockSuccess': '{{name}} is geblokkeerd',
  'admin.users.unblockSuccess': '{{name}} is gedeblokkeerd',
  'admin.users.removeFreeSuccess': 'Gratis status van {{name}} is verwijderd',
  
  'admin.downgrade.plans.builder': 'Builder',
  'admin.downgrade.plans.pro': 'Pro',
  'admin.downgrade.plans.starter': 'Starter',
  'admin.downgrade.plans.free': 'Gratis',
  
  'admin.unit.percent': '%',

  'admin.tips.discoverNewFeature': 'Ontdek Nieuwe Functie',
  'admin.tips.productivityBoost': 'Productiviteitsboost',
  'admin.tips.importantUpdate': 'Belangrijke Update',
  'admin.tips.tipOfDay': 'Tip van de Dag',

  'admin.actions.activate': 'Activeren',
  'admin.actions.deactivate': 'Deactiveren',
  'admin.websiteEditor.tab.features': 'Functies',
  'admin.websiteEditor.tab.testimonials': 'Getuigenissen',
  'admin.websiteEditor.tab.faq': 'FAQ',
  'admin.websiteEditor.tab.cta': 'CTA',
  'admin.websiteEditor.tab.footer': 'Footer',
  'admin.websiteEditor.tab.design': 'Ontwerp',
  'admin.websiteEditor.tab.customcode': 'Aangepaste Code',
  'admin.websiteEditor.tab.socials': 'Sociale Media',
  'admin.websiteEditor.tab.importexport': 'Importeren/Exporteren',

  // --- AI Instellingen Editor ---
  'admin.ai.title': 'AI Assistent Instellingen',
  'admin.ai.subtitle': 'Configureer gedrag, stijl en analysediepte',
  'admin.ai.smartWeightingActive': 'Slimme Weging Actief',
  'admin.ai.smartWeightingDesc': 'De AI combineert automatisch alle perspectieven met slimme weging. Bij meerdere presets wordt de eerste zwaarder gewogen (primaire preset). U kunt de weging ook handmatig aanpassen.',
  'admin.ai.modelTitle': 'IdeaVerdict AI Model',
  'admin.ai.modelSubtitle': 'Kies de AI-engine voor alle gebruikersanalyses',
  'admin.ai.activeModel': 'Actief model:',
  'admin.ai.activeModelDesc': 'Alle gebruikers ontvangen antwoorden van dit model.',
  'admin.ai.recommendations': 'Aanbevelingen voor Optimale Resultaten',
  'admin.ai.new': 'NIEUW',
  'admin.ai.recommendationsDesc': 'Bewezen presetcombinaties voor de beste analysekwaliteit',
  'admin.ai.recommendationsInfo': 'Deze combinaties zijn getest en leveren de beste resultaten. Klik op een aanbeveling om deze direct toe te passen.',
  'admin.ai.active': 'ACTIEF',
  'admin.ai.apply': 'Toepassen',
  'admin.ai.avoid': 'Vermijden',
  'admin.ai.excellentQuality': 'Uitstekende Kwaliteit',
  'admin.ai.goodQuality': 'Goede Kwaliteit',
  'admin.ai.poorQuality': 'Verdunde Kwaliteit - Niet Aanbevolen',
  'admin.ai.proTips': 'Pro Tips',
  'admin.ai.tip1Title': '2 presets zijn optimaal:',
  'admin.ai.tip1Desc': 'Duidelijk perspectief zonder verdunning',
  'admin.ai.tip2Title': 'Primaire preset is belangrijk:',
  'admin.ai.tip2Desc': 'De eerste preset heeft de grootste invloed',
  'admin.ai.tip3Title': 'Vermijd tegenstellingen:',
  'admin.ai.tip3Desc': '"EXTREEM" + "Creatief" = tegenstrijdig',
  'admin.ai.tip4Title': 'Maximaal 3 presets:',
  'admin.ai.tip4Desc': 'Bij 4+ presets wordt het resultaat te algemeen',
  'admin.ai.warningManyPresets': 'Waarschuwing: Veel Presets',
  'admin.ai.warningManyPresetsDesc': 'U heeft {{count}} presets geselecteerd. Dit kan het resultaat verdunnen.',
  'admin.ai.warningRecommend': 'Aanbevolen: Maximaal 2-3 presets',
  'admin.ai.forOptimalResults': 'voor optimale resultaten.',
  'admin.ai.presets': 'Presets',
  'admin.ai.multiSelect': '(meerdere selecties mogelijk)',
  'admin.ai.presetsDesc': 'Kies een of meerdere presets. De eerste preset is de primaire preset met de hoogste weging.',
  'admin.ai.primaryPreset': 'Primaire Preset',
  'admin.ai.weightControl': 'Wegingscontrole',
  'admin.ai.weightControlDesc': 'Pas aan hoe sterk elke preset de analyse beïnvloedt',
  'admin.ai.manual': 'Handmatig',
  'admin.ai.automatic': 'Automatisch',
  'admin.ai.autoWeightingActive': 'Automatische weging actief:',
  'admin.ai.autoWeightingDesc': 'De weging wordt automatisch geoptimaliseerd op basis van het aantal presets.',
  'admin.ai.primary': 'PRIMAIR',
  'admin.ai.totalWeight': 'Totaal',
  'admin.ai.shouldBe100': 'moet 100% zijn',
  'admin.ai.normalize': 'Normaliseren',
  'admin.ai.combinedSettings': 'Gecombineerde Instellingen',
  'admin.ai.presetsCount': 'presets',
  'admin.ai.strictness': 'Strengheid',
  'admin.ai.realism': 'Realisme',
  'admin.ai.creativity': 'Creativiteit',
  'admin.ai.detailLevel': 'Detailniveau',
  'admin.ai.customInstructions': 'Aangepaste Instructies',
  'admin.ai.customInstructionsDesc': 'Extra instructies die worden gecombineerd met de presets',
  'admin.ai.customInstructionsPlaceholder': 'bv. "Focus op de Benelux-markt", "Gebruik altijd concrete cijfers", "Vergelijk met bestaande concurrenten", "Antwoord altijd met voorbeelden"...',
  'admin.ai.customInstructionsHint': 'Deze instructies worden automatisch gecombineerd met de geselecteerde presets.',
  'admin.ai.manualFinetuning': 'Handmatige Fine-Tuning',
  'admin.ai.manualFinetuningHint': '(optioneel, overschrijft presetwaarden)',
  'admin.ai.manualFinetuningDesc': 'Pas de gecombineerde waarden handmatig aan als u iets wilt verfijnen.',
  'admin.ai.tone': 'Toon',
  'admin.ai.mild': 'Mild',
  'admin.ai.strict': 'Streng',
  'admin.ai.creative': 'Creatief',
  'admin.ai.realistic': 'Realistisch',
  'admin.ai.conservative': 'Conservatief',
  'admin.ai.compact': 'Compact',
  'admin.ai.detailed': 'Gedetailleerd',
  'admin.ai.responseLength': 'Antwoordlengte',
  'admin.ai.short': 'Kort & Bondig',
  'admin.ai.medium': 'Gemiddeld',
  'admin.ai.long': 'Gedetailleerd',
  'admin.ai.focusAreas': 'Analyse Focusgebieden',
  'admin.ai.autoRating': 'Automatische Beoordeling',
  'admin.ai.autoRatingDesc': 'Elke analyse ontvangt automatisch een beoordeling (Goed/Gemiddeld/Slecht)',
  'admin.ai.showSources': 'Toon Bronnen',
  'admin.ai.showSourcesDesc': 'Verwijzingen naar gegevensbronnen en marktgegevens in antwoorden',
  'admin.ai.hidePreview': 'Verberg Voorbeeld',
  'admin.ai.showPreview': 'Toon Voorbeeld',
  'admin.ai.aiBehavior': 'AI Gedrag',
  'admin.ai.length': 'Lengte',
  'admin.ai.liveExample': 'Live Voorbeeld',
  'admin.ai.testSettings': 'Test uw instellingen',
  'admin.ai.selectExampleQuestion': 'Selecteer voorbeeldvraag:',
  'admin.ai.userAsks': 'Gebruiker vraagt:',
  'admin.ai.generating': 'AI genereert antwoord...',
  'admin.ai.generateExample': 'Genereer Voorbeeldantwoord',
  'admin.ai.aiResponds': 'AI Assistent antwoordt:',
  'admin.ai.generateHint': 'Klik op "Genereer Voorbeeldantwoord" om te zien hoe de AI reageert met uw instellingen.',
  'admin.ai.reset': 'Reset',
  'admin.ai.saved': 'Opgeslagen!',
  'admin.ai.saveSettings': 'Instellingen Opslaan',

  // --- Tabelkoppen ---
  'admin.coupons.code': 'Code',
  'admin.coupons.credits': 'Credits',

  // --- AI Model Beschrijvingen ---
  'admin.ai.model.standardDesc': 'Gebalanceerde analyse met hoge kwaliteit. De beste keuze voor de meeste nichebeoordelingen en ideevalidaties.',
  'admin.ai.model.preciseAnalyses': 'Nauwkeurige Analyses',
  'admin.ai.model.bestBalance': 'Beste Balans',
  'admin.ai.model.recommended': 'Aanbevolen',
  'admin.ai.model.fastDesc': 'Bliksemsnelle reacties voor snelle nichechecks, brainstorms en eerste beoordelingen. Ideaal wanneer snelheid belangrijk is.',
  'admin.ai.model.fast': 'SNEL',
  'admin.ai.model.fastestResponses': 'Snelste Reacties',
  'admin.ai.model.thinkingDesc': 'Diepgaande analyse met geavanceerd logisch denken. Voor complexe marktanalyses, kritische beoordelingen en strategische planning.',
  'admin.ai.model.deepestAnalysis': 'Diepste Analyse',
  'admin.ai.model.logicalThinking': 'Logisch Denken',
  'admin.ai.model.strategy': 'Strategie',

  // --- AI Preset Namen & Beschrijvingen ---
  'admin.ai.preset.strict.name': 'Strenge Analyse',
  'admin.ai.preset.strict.desc': 'Kritisch, feitelijk, geen opsmuk. Onthult genadeloos zwaktes.',
  'admin.ai.preset.extreme.name': 'EXTREME Analyse',
  'admin.ai.preset.extreme.desc': 'Maximale strengheid, meedogenloze kritiek, worst-case focus. Alleen voor zware realiteitschecks.',
  'admin.ai.preset.professional.name': 'Professioneel',
  'admin.ai.preset.professional.desc': 'Objectief, gestructureerd, gebalanceerd. Als een ervaren bedrijfsadviseur.',
  'admin.ai.preset.realistic.name': 'Realistisch',
  'admin.ai.preset.realistic.desc': 'Eerlijk en praktisch. Focus op haalbare implementatie en reële marktgegevens.',
  'admin.ai.preset.creative.name': 'Creatief & Motiverend',
  'admin.ai.preset.creative.desc': 'Inspirerend, ideeënrijk, positief. Vindt kansen en onconventionele paden.',
  'admin.ai.preset.balanced.name': 'Gebalanceerd',
  'admin.ai.preset.balanced.desc': 'Goede mix van kritiek en motivatie. De standaardmodus.',
  'admin.ai.preset.investor.name': 'Investeerdersperspectief',
  'admin.ai.preset.investor.desc': 'Als een Venture Capitalist. Focus op schaling, ROI en exitstrategie.',
  'admin.ai.preset.startup-coach.name': 'Startup Coach',
  'admin.ai.preset.startup-coach.desc': 'Praktische mentor voor oprichters. Focus op snelle implementatie en MVP.',
  'admin.ai.preset.market-researcher.name': 'Marktonderzoeker',
  'admin.ai.preset.market-researcher.desc': 'Datagedreven en analytisch. Diepgaande markt- en concurrentieanalyse.',
  'admin.ai.preset.risk-analyst.name': 'Risicoanalist',
  'admin.ai.preset.risk-analyst.desc': 'Focus op risico\'s en worst-case scenario\'s. Voor realistische planning.',

  // --- Focusgebieden ---
  'admin.ai.focus.marktanalyse': 'Marktanalyse',
  'admin.ai.focus.wettbewerb': 'Concurrentie',
  'admin.ai.focus.monetarisierung': 'Monetisatie',
  'admin.ai.focus.risiken': 'Risico\'s',
  'admin.ai.focus.finanzen': 'Financiën',
  'admin.ai.focus.skalierung': 'Schaalbaarheid',
  'admin.ai.focus.innovation': 'Innovatie',
  'admin.ai.focus.trends': 'Trends',
  'admin.ai.focus.differenzierung': 'Differentiatie',
  'admin.ai.focus.umsetzung': 'Implementatie',
  'admin.ai.focus.zielgruppe': 'Doelgroep',
  'admin.ai.focus.marketing': 'Marketing',

  // --- Toon Opties ---
  'admin.ai.tone.direkt': 'Direct & Bot',
  'admin.ai.tone.professionell': 'Professioneel & Objectief',
  'admin.ai.tone.ehrlich': 'Eerlijk & Praktisch',
  'admin.ai.tone.motivierend': 'Motiverend & Positief',
  'admin.ai.tone.freundlich': 'Vriendelijk & Ondersteunend',
  'admin.ai.tone.akademisch': 'Academisch & Analytisch',

  // --- Voorbeeldvragen ---
  'admin.ai.question.niche': 'Welke winstgevende niche raadt u aan?',
  'admin.ai.question.evaluate': 'Beoordeel mijn idee: Een app voor hondenbezitters',
  'admin.ai.question.trends': 'Welke trends hebben momenteel potentie?',
  'admin.ai.question.sharpen': 'Hoe kan ik mijn niche aanscherpen?',

  'admin.ai.rec.bestCombination.title': '🏆 Beste Combinatie (2 Presets)',
  'admin.ai.rec.bestCombination.desc': 'Kritisch maar constructief, met concrete actiestappen',
  'admin.ai.rec.bestCombination.useCase': 'Aanbevolen voor de meeste analyses',

  'admin.ai.rec.balancedThree.title': '⚖️ Gebalanceerd (3 Presets)',
  'admin.ai.rec.balancedThree.desc': 'Professioneel, realistisch en investeerdersvriendelijk',
  'admin.ai.rec.balancedThree.useCase': 'Voor uitgebreide bedrijfsanalyses',

  'admin.ai.rec.creativeDriven.title': '💡 Creatief & Motiverend (2 Presets)',
  'admin.ai.rec.creativeDriven.desc': 'Inspirerend met praktische implementatietips',
  'admin.ai.rec.creativeDriven.useCase': 'Voor ideevorming en brainstormsessies',

  'pdf.rating.good': 'Good',
  'pdf.rating.bad': 'Bad',
  'pdf.rating.medium': 'Medium',
  'pdf.header.subtitle': 'Analysis View',
  'pdf.footer.tagline': 'AI-Powered Niche Validation',
  'pdf.footer.page': 'Page',
  'pdf.benchmark.title': 'INDUSTRY BENCHMARK',
  'pdf.benchmark.yourScore': 'Your Score',
  'pdf.benchmark.top10': 'Top 10%: 85+',
  'pdf.marketAnalysis.title': 'MARKET ANALYSIS',
  'pdf.summary.title': 'SUMMARY',
  'pdf.structuredSummary.verdict': 'VERDICT',
  'pdf.disclaimer.body': 'This report was generated by an AI model and is intended for informational purposes only. It does not constitute financial, legal, tax, or investment advice. Market data, ratings, and projections are AI-generated estimates and may be incomplete or inaccurate. Please verify all information independently and consult qualified professionals before making any business or investment decisions. IdeaVerdict assumes no liability for actions taken based on this report.',
  'pdf.disclaimer.title': 'IMPORTANT NOTICE',
  'pdf.closing.title': 'Generated by IdeaVerdict',
  'pdf.closing.subtitle': 'AI-Powered Niche Validation  |  Comprehensive Market Intelligence',
  'history.swot.title': 'SWOT Analysis',
  'history.swot.strengths': 'Strengths',
  'history.swot.weaknesses': 'Weaknesses',
  'history.swot.opportunities': 'Opportunities',
  'history.swot.risks': 'Risks',
  'history.sections.recommendations': 'Recommendations',
  'history.sections.marketAnalysis': 'Competitive Analysis',
  'history.sections.microAngles': 'Micro-Niche Angles',
  'history.sections.improvements': 'Improvement Suggestions',
  'history.sections.alternatives': 'Alternative Niches',
  'history.sections.structuredSummary': 'Structured Summary (Builder)',
  'history.structuredSummary.strengths': 'Top Strengths',
  'history.structuredSummary.risks': 'Top Risks',
  'history.structuredSummary.actions': 'Next Steps',
  'history.sections.developerBriefing': 'Developer Briefing (Builder)',
  'history.sections.conversation': 'Conversation History',
  'history.conversation.user': 'User',
  'history.conversation.assistant': 'IdeaVerdict',
  'history.conversation.structuredResult': 'Structured Result',
  'admin.tabs.usage': 'Usage',
  'admin.usage.title': 'AI Usage & Cost Analysis',
  'admin.usage.refresh': 'Refresh data',
  'admin.usage.requests': 'Requests',
  'admin.usage.users': 'Users',
  'admin.usage.totalTokens': 'Total Tokens',
  'admin.usage.apiCosts': 'API Costs',
  'admin.usage.revenue': 'Revenue',
  'admin.usage.margin': 'Margin',
  'admin.usage.byModel': 'By Model',
  'admin.usage.allModels': 'All Models',
  'admin.usage.searchEmail': 'Search by email address...',
  'admin.usage.perPage': 'Per page:',
  'admin.usage.loading': 'Loading usage data...',
  'admin.usage.noEntries': 'No entries found for current filters.',
  'admin.usage.time': 'Time',
  'admin.usage.user': 'User',
  'admin.usage.model': 'Model',
  'admin.usage.credits': 'Credits',
  'admin.usage.tokens': 'Tokens',
  'admin.usage.duration': 'Duration',
  'admin.usage.details': 'Details',
  'admin.usage.showing': 'Showing',
  'admin.usage.of': 'of',
  'admin.usage.entries': 'entries',
  'admin.usage.firstPage': 'First Page',
  'admin.usage.prevPage': 'Previous',
  'admin.usage.page': 'Page',
  'admin.usage.nextPage': 'Next',
  'admin.usage.lastPage': 'Last Page',
  'admin.usage.requestDetails': 'Request Details',
  'admin.usage.close': 'Close',
  'admin.usage.loadingDetails': 'Loading details...',
  'admin.usage.inputTokens': 'Input Tokens',
  'admin.usage.outputTokens': 'Output Tokens',
  'admin.usage.providerCost': 'Provider Cost',
  'admin.usage.providerBreakdown': 'Provider Breakdown',
  'admin.usage.fullResponseData': 'Full Response Data',
  'admin.usage.entryNotFound': 'This entry could not be loaded.',
  'admin.usage.today': 'Today',
  'admin.usage.last7d': 'Last 7 Days',
  'admin.usage.last30d': 'Last 30 Days',
  'admin.usage.allTime': 'All Time',
  'admin.ai.fallbackModel': 'Fallback Model',
  'admin.ai.systemPrompts': 'System Prompts',
  'admin.ai.fallbackModelDesc': 'Used when the primary model fails or returns invalid output',
  'admin.ai.systemPromptsDesc': 'Read-only view of what each model receives as instructions',
  'admin.ai.provider': 'Provider',
  'admin.ai.modelId': 'Model ID',
  'admin.ai.maxTokens': 'Max Tokens',
  'admin.ai.temperature': 'Temperature',
  'admin.ai.thinkingBudget': 'Thinking Budget',
  'admin.ai.supportsThinking': 'Supports Thinking',
  'admin.ai.displayName': 'Display Name',
  'admin.ai.precise': 'Precise',
  'admin.ai.creativeTemp': 'Creative',

  // Header + Sidebar (auto-added by rebrand)
  'header.openMenu': 'Menu openen',
  'header.home': 'Home',
  'header.notifications': 'Meldingen',
  'header.settings': 'Instellingen',
  'header.profile': 'Profiel',
  'sidebar.collapse': 'Zijbalk inklappen',
  'sidebar.expand': 'Zijbalk uitklappen',
  'sidebar.close': 'Menu sluiten',
  'sidebar.plan': 'Plan',
  'sidebar.backToWebsite': 'Terug naar website',

  // Legal — Imprint (auto-added)
  'legal.imprint.title': 'Imprint',
  'legal.imprint.company': 'Scherbius Technology',
  'legal.imprint.location': 'Dubai, United Arab Emirates (UAE)',
  'legal.imprint.seatLabel': 'Registered office',
  'legal.imprint.seatBody': 'Dubai, United Arab Emirates',
  'legal.imprint.contactLabel': 'Contact',
  'legal.imprint.contactBody': 'Contact details are provided at the sole discretion of Scherbius Technology.',
  'legal.imprint.representationLabel': 'Legal representation',
  'legal.imprint.representationBody': 'Scherbius Technology is represented by its legal representatives in accordance with the laws of the United Arab Emirates.',
  'legal.imprint.contentLiabilityLabel': 'Liability for content',
  'legal.imprint.contentLiabilityBody': 'The contents of this website have been created with the greatest possible care.\nHowever, Scherbius Technology assumes no liability for the accuracy, completeness or timeliness of the content.',
  'legal.imprint.linksLiabilityLabel': 'Liability for external links',
  'legal.imprint.linksLiabilityBody': 'This website may contain links to external third-party websites whose content we have no control over.\nNo liability is assumed for these external contents.',
  'legal.imprint.lawLabel': 'Applicable law',
  'legal.imprint.lawBody': 'The laws of the United Arab Emirates apply exclusively.\nPlace of jurisdiction is Dubai, UAE.',

  // Overview page (auto-added)
  'overview.greeting': 'Welkom terug',
  'overview.greetingSub': 'Dit gebeurt er op je verdict-bureau.',
  'overview.heroCta': 'Nieuw oordeel',
  'overview.currentPlan': 'Huidig plan',
  'overview.creditsLabel': 'credits',
  'overview.usedThisCycle': 'Gebruikt deze cyclus',
  'overview.resetsOn': 'Reset op',
  'overview.unlimitedTitle': 'Onbeperkt',
  'overview.builderPerk': 'Je hebt volledige Builder-toegang — geen limieten.',
  'overview.runOne': 'Start een oordeel',
  'overview.lastVerdicts': 'Je laatste 5 oordelen',
  'overview.noActivity': 'Nog geen oordelen — start je eerste analyse',
  'overview.tipTitle': 'Tip',
  'overview.tipBody': 'Laat een idee door twee talen lopen — als het oordeel zachter wordt, zijn je aannames lokaal, niet universeel.',
  'onboard.skip': "Overslaan",
  'onboard.cta.next': "Volgende",
  'onboard.cta.start': "Aan de slag",
  'onboard.s1.title': "Welkom bij IdeaVerdict",
  'onboard.s1.body': "Een AI-oordeel over je bedrijfsidee — voordat je het bouwt.",
  'onboard.s2.title': "Bruut eerlijke oordelen",
  'onboard.s2.body': "Geen hype, geen vleierij. Echte marktdata, echte concurrenten, echte risico's.",
  'onboard.s3.title': "Builder-rapporten als PDF",
  'onboard.s3.body': "Genereer rapporten van 25 tot 75 pagina's met volledige architectuur, financiën en go-to-market strategie.",
  'onboard.s4.title': "Klaar wanneer jij het bent",
  'onboard.s4.body': "Meld je aan en krijg je eerste oordeel in minder dan een minuut.",
  'builderReport.title': "Je Builder Report wordt gemaakt",
  'builderReport.subtitle': "Uitgebreide analyse + developer briefing — wordt als PDF gedownload zodra het klaar is.",
  'builderReport.idea': "Jouw idee",
  'builderReport.ideaPlaceholder': "Beschrijf je bedrijfsidee…",
  'builderReport.cta': "Rapport genereren",
  'builderReport.credits': "credits",
  'builderReport.deductedNow': "Wordt afgeschreven bij succes",
  'builderReport.dontClose': "Sluit dit venster niet — genereren kan 30-90 seconden duren.",
  'builderReport.done': "PDF gedownload — kijk in je downloads-map.",
  'builderReport.failed': "Generatie mislukt",
  'builderReport.close': "Sluiten",
  'builderReport.cancel': "Annuleren",
  'builderReport.running': "Bezig met genereren…",
  'builderReport.retry': "Opnieuw proberen",
  'builderReport.unknownError': "Genereren mislukt. Je credits worden terugbetaald.",
  'builderReport.signInRequired': "Je moet ingelogd zijn om een rapport te genereren.",
  'builderReport.ideaRequired': "Beschrijf je idee zodat de AI iets heeft om te analyseren.",
  'builderReport.fromChat': "Uit je huidige gesprek",
  'builderReport.noIdeaDetected': "We gebruiken het idee dat we hebben besproken.",
  'builderReport.contextHint': "De AI gebruikt alles uit deze chat — er wordt geen nieuw idee bedacht.",
  'builderReport.step.core': "Kernanalyse genereren",
  'builderReport.step.market': "Uitgebreide marktanalyse toevoegen",
  'builderReport.step.tech': "Technische architectuur toevoegen",
  'builderReport.step.financials': "Financiële modellen toevoegen",
  'builderReport.step.compet': "Concurrentie-intelligentie toevoegen",
  'builderReport.step.gtm': "Go-to-market-strategie toevoegen",
  'builderReport.step.deepdive': "Branchespecifieke diepteanalyse toevoegen",
  'builderReport.step.pdf': "PDF wordt samengesteld…",
  'briefing.title': "Developer briefing wordt gemaakt",
  'briefing.subtitle': "11-secties technische briefing — wordt als PDF gedownload zodra het klaar is.",
  'briefing.ideaPlaceholder': "Beschrijf je bedrijfsidee…",
  'briefing.cta': "Briefing genereren",
  'briefing.step.core': "Developer briefing genereren",
  'briefing.step.pdf': "PDF wordt samengesteld…",
  'pricing.gold.name': "Gold",
  'pricing.gold.description': "Meer credits + 50-pagina-rapporten",
  'pricing.gold.credits': "12.500 credits per maand",
  'pricing.platinum.name': "Platinum",
  'pricing.platinum.description': "Hoogste tier + 75-pagina-rapporten",
  'pricing.platinum.credits': "15.000 credits per maand",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "nl" yet. Replace with native translations as needed.
  'nav.slogan': 'An AI verdict on your business idea — before you build',
  'chat.creditsPerQuestion': 'Credits/question',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.notEnoughCreditsDesc': 'You need at least {{cost}} credits per question.',
  'chat.creditsRunningLow': 'Credits running low',
  'chat.questionsRemaining': '{{count}} questions remaining.',
  'chat.noCreditsModalTitle': 'Not enough credits',
  'chat.noCreditsModalDesc': 'You need at least <1>{{cost}} credits</1> per question. Your current balance: <2>{{balance}} credits</2>',
  'chat.currentPlan': 'Current plan',
  'chat.close': 'Close',
  'chat.upgrade': 'Upgrade',
  'sub.manageBilling': 'Manage billing',
  'credits.topup.buyMore': 'Buy more credits',
  'trial.creditsLow': "Nog maar {{count}} credits!",
  'trial.upgradeNow': "Nu upgraden",
  'trial.upgradeNowArrow': "Nu upgraden →",
  'trial.creditsExhausted': "Credits op",
  'trial.upgradeForUnlimited': "Upgrade voor onbeperkt gebruik",
  'trial.noCreditsPlaceholder': "Geen credits meer beschikbaar…",
  'hero.badgeHonest': "Eerlijke, onbevooroordeelde AI",
  'hero.badge60sec': "Oordeel in 60 seconden",
  'hero.badge20Lang': "20+ talen",
  'hero.widget.label': "Idee-oordeel",
  'hero.widget.passed': "GOEDGEKEURD",
  'hero.widget.demoIdea': "AI-tutor voor medische studenten",
  'hero.widget.market': "Markt",
  'hero.widget.demand': "Vraag",
  'hero.widget.competition': "Concurrentie",
  'hero.widget.verdictReady': "Oordeel klaar · 47 sec",
  'hero.widget.riskFlagged': "Risico gemarkeerd",
  'hero.widget.crowdedMarket': "Overvolle markt · 4 spelers",
  'hero.widget.suggestedPivot': "Voorgestelde pivot",
  'hero.widget.nicheBySpecialty': "Niche per specialisme",
  'hero.widget.feasibilityGain': "+38% haalbaarheid",
  'hero.widget.analysisDone': "Analyse klaar",
  'hero.widget.metrics56': "5 van 6 metrics",
  'hero.stats.verdictSpeed': "Snelheid van oordeel",
  'cta.badge': "Oordeel in 60 seconden",
  'cta.subtitleEnd': "zonder te gokken.",
  'cta.signinPrompt': "Heb je al een account? Inloggen",
  'cta.trustTrial': "7 dagen gratis proefperiode",
  'cta.trustNoCard': "Geen kaart nodig",
  'cta.trustCancel': "Annuleer wanneer je wilt",
  'footer.themeLabel': "Thema:",
  'footer.lightMode': "Lichte modus",
  'footer.darkMode': "Donkere modus",
  'footer.sectionProduct': "Product",
  'footer.sectionLegal': "Juridisch",
  'nav.switchLight': "Schakel naar lichte modus",
  'nav.switchDark': "Schakel naar donkere modus",
  'features.badge': "Waarom IdeaVerdict",
  'features.mainFeatureLabel': "Kop",
  'chatError.planRestriction': "Deze functie vereist een hoger abonnement.",
  'chatError.creditDeduction': "Betaling mislukt. Probeer het opnieuw.",
  'chatError.aiService': "AI-service tijdelijk niet beschikbaar. Je credits zijn niet in rekening gebracht. Probeer het opnieuw.",
  'chatError.parseError': "Onverwachte antwoordindeling ontvangen. Probeer het opnieuw.",
  'chatError.sessionExpired': "Je sessie is verlopen. Log opnieuw in.",
  'chatError.timeout': "De aanvraag duurde te lang. Probeer het opnieuw.",
  'chatError.generic': "Kan geen antwoord krijgen. Probeer het opnieuw.",

  // ─── Auto-backfilled from EN (2026-05-13) ───
  // These are English fallbacks for keys that hadn't been translated to
  // "nl" yet. Replace with native translations as needed.
  'faq.badge': "FAQ",
  'trial.lowCredits': "Only {credits} credits left!",
  'trial.outOfCredits': "Out of credits",
  'trial.outOfCreditsDesc': "Upgrade to keep getting verdicts.",
  'trial.viewPlans': "View plans",
  'trial.tryDemo': "Try the demo",
  'hero.widget.crowded': "Crowded market · 4 incumbents",
  'hero.widget.nicheBySpec': "Niche by specialty",
  'hero.widget.feasibilityUp': "+38% feasibility",
  'hero.widget.fiveOfSix': "5 of 6 metrics",
  'builderReport.modalTitle': "Builder Report",
  'builderReport.modalSubtitle': "Generate a comprehensive PDF for your idea",
  'builderReport.formatLabel': "Report format",
  'builderReport.formatStandard': "Standard report",
  'builderReport.formatExec': "Executive summary",
  'builderReport.toneLabel': "Tone",
  'builderReport.toneProfessional': "Professional",
  'builderReport.toneCasual': "Casual",
  'builderReport.toneTechnical': "Technical",
  'builderReport.sectionsLabel': "Sections to include",
  'builderReport.sectionMarket': "Market analysis",
  'builderReport.sectionCompetition': "Competitive landscape",
  'builderReport.sectionFinancial': "Financial model",
  'builderReport.sectionArchitecture': "Technical architecture",
  'builderReport.sectionGTM': "Go-to-market plan",
  'builderReport.sectionRisks': "Risk register",
  'builderReport.sectionRoadmap': "Product roadmap",
  'builderReport.sectionTeam': "Team & hiring plan",
  'builderReport.actionGenerate': "Generate report",
  'builderReport.actionCancel': "Cancel",
  'builderReport.actionDownload': "Download PDF",
  'builderReport.statusGenerating': "Generating your report…",
  'builderReport.statusComplete': "Report ready",
  'builderReport.statusError': "Something went wrong. Try again.",
  'builderReport.creditsRequired': "This will use {credits} credits.",
  'builderReport.pageCount': "{pages} pages",
  'builderReport.tip1': "Tip: be specific about your target customer for sharper analysis.",
  'builderReport.tip2': "Tip: include early revenue numbers if you have them.",
  'builderReport.tip3': "Tip: mention your tech preferences if any.",
  'builderReport.errorNotEnough': "You don't have enough credits for this report.",
  'builderReport.errorUpgrade': "Upgrade to a higher plan",
  'builderReport.errorTryStandard': "Try the Standard report instead",
  'builderReport.success': "Your Builder Report is ready.",
  'builderReport.previewBadge': "Preview",
  'builderReport.previewNote': "This is a preview. Generate the full PDF to see all sections.",
  'builderReport.includesLabel': "Includes",
  'builderReport.pagesIncluded': "{pages} pages of analysis",
  'builderReport.estimatedTime': "Estimated time: {minutes} min",
  'builderReport.fullReport': "Full report",
  'builderReport.execSummary': "Executive summary",
  'pricing.builder.report': "25-pagina Builder Report",
  'pricing.gold.report': "50-pagina Builder Report",
  'pricing.platinum.report': "75-pagina Builder Report",
  'auth.bestValue': "Beste keuze",
  'auth.elite': "Elite",
  'builderReport.friendlyError': "We konden je rapport deze keer niet afronden. Je credits zijn niet in rekening gebracht — probeer het over een moment opnieuw.",
  'builderReport.persistHint': "Als dit blijft gebeuren, neem contact op met support@ideaverdict.ai.",
};
